window.repeatedCoffeedata = [];
class RechargeDashboard extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    this.noSubscriptionAccount = false;
    document.addEventListener('DOMContentLoaded',() => {
      this.init();
    });
  }

  async init() {
    await getRechargeSession();
    await getAllProducts();
    console.log("window.rechargeSession",window.rechargeSession);
    if(window.rechargeSession.customerId == null){
      this.noSubscriptionAccount = true;
      window.scrollTo(0,0);
      window.dispatchEvent(new CustomEvent('resize'));
    }
    const checkInterval = setInterval(async () => {
      if(window.rechargeSession && window.playlistLoaded){
        clearInterval(checkInterval);
        this.initialized = true;
        await this.storeSetupData()
      }
   }, 750);
   console.log("✅ init completed");
  }

  async storeSetupData() {
    const accountDashboardLoader = document.querySelector('[data-account-dashboard-loader]');
    if(accountDashboardLoader.classList.contains('loaded')){
      accountDashboardLoader.classList.remove('loaded');
      this.classList.add('hidden'); 
      window.scrollTo(0,0);
    }
    
    // if user not in recharge (For the user who has only one time order)
    if(this.noSubscriptionAccount){
      this.activeBundleSubscriptions = [];
      await this.renderDiscoverCoffees();
      await this.setUpFlavourProfile();
      if(this.querySelector('[data-manage-subscription-button]')){
        this.querySelector('[data-manage-subscription-button]').classList.add('hidden');
      }
      if(this.querySelector('[data-address-payment-action]')){
        this.querySelector('[data-address-payment-action]').addEventListener('click',() => {
         window.location.href = '/account/addresses';
        });
      }
      accountDashboardLoader.classList.add('loaded');
      this.classList.remove('hidden'); 
      applySpacingDivDummy();
      window.dispatchEvent(new Event('resize'));
      return;
    }
    // end of user not in recharge
    
    await this.fetchHeartedProducts();
    if(this.querySelector('current-order-block')){
      await this.querySelector('current-order-block').setupCurrentOderBlock();
      console.log("✅ setupCurrentOderBlock Completed")
    }
    await this.getCustomerData();
    this.milestone();
    await this.getReferFriendData();
    await this.getCreditData();
    await this.getSubscriptionData();
    await this.getChargesData();
    await this.getNextPrepaidSubscriptionOrder();
    await this.getNextSubscriptionOrder();
    await this.renderDiscoverCoffees();
    await this.renderCuratedPlaylists();
    await this.setAddressData()
    await this.renderPaymentMethods();
    await this.setUpFlavourProfile();
    await this.renderActiveSubscriptions();
    await this.renderInactiveSubscriptions();
    await this.renderPlaylistCarousel();
    accountDashboardLoader.classList.add('loaded');
    this.classList.remove('hidden'); 
    console.log("✅ storeSetupData");
    applySpacingDivDummy();
    window.dispatchEvent(new Event('resize'));
    console.log("✅ storeSetupData Completed")
  }
  async getChargesData() {
    try {
    const chargesDataResponse = await recharge.charge.listCharges(window.rechargeSession,
      {
      limit: 25,
      status: 'queued',
      sort_by: 'scheduled_at-desc',
      });
    this.queuedChargesData = chargesDataResponse.charges;
    console.log("✅ Get Charges Completed") 
    } catch (error) {
      console.error("🚨 Error sending request:", error.message);
      this.chargesData = [];
    }
  }
  milestone(){
    if(this.querySelector('.milestone-section')){
      const milestoneItems = this.querySelectorAll('.milestone-item');
      let current = parseInt(this.customerData.subscription_related_charge_streak);
      const milestones = Array.from(document.querySelectorAll('.min-milestone'))
        .map(el => parseInt(el.textContent.trim()))
        .filter(num => !isNaN(num)); 
      const nextMilestone = milestones.find(m => m > current);

      if (nextMilestone !== undefined) {
        const difference = nextMilestone - current;
        if(this.querySelector('.next-milestone-value')){
          this.querySelector('.next-milestone-value').innerHTML = nextMilestone;
        }
        console.log(`Next milestone: ${nextMilestone}`);
        console.log(`Steps left: ${difference}`);
        if(this.querySelector('.milestone-progress-value')){
          this.querySelector('.milestone-progress-value').textContent = difference;
        }
      } else {
        this.querySelector('.milestone-section').style.display = 'none';
        console.log("You have reached or passed the last milestone!");
      }
      console.log("✅ Milestone Completed")
    }
  }
  async renderPlaylistCarousel() {
    const playlistCarouselElement = this.querySelectorAll('playlist-carousel');
    playlistCarouselElement.forEach(element => {
      element.triggerPlaylistCarousel();
    });
    console.log("✅ renderPlaylistCarousel Completed")
  }
  async renderActiveSubscriptions() {
    const activeSubscriptionsElement = this.querySelector('[data-active-subscriptions]');
    activeSubscriptionsElement.innerHTML = '';
    if(this.activeSubscriptions.length == 0){
      activeSubscriptionsElement.innerHTML = 'No active subscriptions';
      return;
    }
    this.activeSubscriptions.forEach(subscription => {
      activeSubscriptionsElement.innerHTML += this.createActiveSubscriptionsHTML(subscription);
    });
    console.log("✅ renderActiveSubscriptions Completed")
  }
  async renderInactiveSubscriptions() {
    const inactiveSubscriptionsElement = this.querySelector('[data-inactive-subscriptions]');
    inactiveSubscriptionsElement.innerHTML = '';
    if(this.inactiveSubscriptions.length == 0){
      inactiveSubscriptionsElement.innerHTML = 'No inactive subscriptions';
      return;
    }
    this.inactiveSubscriptions.forEach(subscription => {
      inactiveSubscriptionsElement.innerHTML += this.createActiveSubscriptionsHTML(subscription);
    });
    console.log("✅ renderInactiveSubscriptions Completed")
  }
  createActiveSubscriptionsHTML(subscription) {
    return `
      <single-product-subscription class="flex flex-col gap-4 justify-between pt-4 pb-4 ps-4 pe-4 rounded-3 lg:flex-row" data-subscription-id="${subscription.id}" data-product-id="${subscription.external_product_id.ecommerce}" data-variant-id="${subscription.external_variant_id.ecommerce}" class="active-subscription-box">
      </single-product-subscription>
    `;
  }
  async fetchHeartedProducts() {
    try {
      if(document.querySelector('current-order-block')){
        const documentOrderId = document.querySelector('current-order-block').getAttribute('data-order-id');
        if(documentOrderId){
          const response = await fetch(`/apps/proxy/coffee/heart/${window.customer.id}/${documentOrderId}`);
          const data = await response.json();
          this.heartedProducts = data.coffee;
          console.log("✅ Fetch Hearted Products Completed")
          return;
        }
      }
    } catch (error) {
      console.error("🚨 Error sending request:", error.message);
      this.heartedProducts = [];
    }
  }

  async setUpFlavourProfile() {
    const customerFlavourProfile = this.querySelector('customer-flavour-profile');
    if(customerFlavourProfile){
     await customerFlavourProfile.renderFlavourProfile();
    }
    console.log("✅ setUpFlavourProfile Completed")
  }
  async getCustomerData() {
    const customerDataResponse = await recharge.customer.getCustomer(window.rechargeSession,{
      include: ['referral_info','payment_methods','addresses']
    });
    this.customerData = customerDataResponse;
    console.log("✅ Get Customer Completed")
  }

  async getCreditData() {
    const creditDataResponse = await recharge.credit.getCreditSummary(window.rechargeSession);
    this.creditData = creditDataResponse;
    console.log("✅ Get Credit Completed")
  }

  async getReferFriendData() {
    if(this.customerData.include.referral_info){
    const referFriendDataResponse = this.customerData.include.referral_info.referral_url.url;
    const referMainBLock = this.querySelector('[data-refer-friend-content]');
    if(referMainBLock){
      referMainBLock.querySelector('[data-refer-friend-email]').innerHTML = referFriendDataResponse;
      referMainBLock.classList.remove('hidden');
      }
      if(referMainBLock.querySelector('[data-refer-copy-button]')){
      referMainBLock.querySelector('[data-refer-copy-button]').setAttribute('data-refer-link',referFriendDataResponse);
      }
    }
    else{
      const referMainBLock = this.querySelector('[data-refer-friend-content]');
      referMainBLock.classList.add('hidden');
    }
    console.log("✅ Get Refer Friend Completed")
  }


  async getSubscriptionData() {
    const subscriptionDataResponse = await recharge.subscription.listSubscriptions(window.rechargeSession,
      {
      limit: 25,
      sort_by: 'updated_at-desc',
      include: ['bundle_product','bundle_selections','metafields','address']
    });
    console.log("subscriptionDataResponse",subscriptionDataResponse);

    this.subscriptionData = subscriptionDataResponse.subscriptions;
    this.activeSubscriptions = subscriptionDataResponse.subscriptions.filter(subscription => subscription.include.bundle_product == null && subscription.status == 'active' && subscription.is_prepaid == false);
    this.inactiveSubscriptions = subscriptionDataResponse.subscriptions.filter(subscription => subscription.status == 'cancelled' && subscription.include.bundle_product == null);
    this.activeBundleSubscriptions = subscriptionDataResponse.subscriptions.filter(subscription => subscription.include.bundle_product != null && subscription.status == 'active' && subscription.is_prepaid == false);
    this.prepaidSubscriptions = subscriptionDataResponse.subscriptions.filter(subscription => subscription.is_prepaid);
    this.activePrepaidSubscriptions = this.prepaidSubscriptions.filter(subscription => subscription.status == 'active');
   
    console.log("✅ Get Subcription Completed")
  }

  async getNextSubscriptionOrder() {
    this.querySelector('[data-next-subscripiton-order]').innerHTML = '';
    const sortedSubscriptions = [...this.activeBundleSubscriptions].sort((a, b) => new Date(a.next_charge_scheduled_at) - new Date(b.next_charge_scheduled_at));
    sortedSubscriptions.forEach(subscription => {
      this.querySelector('[data-next-subscripiton-order]').innerHTML += this.createNextSubscriptionOrderHTML(subscription);
    });
  }

  async getNextPrepaidSubscriptionOrder() {
    this.querySelector('[data-next-prepaid-subscription]').innerHTML = '';
    const sortedSubscriptions = [...this.activePrepaidSubscriptions].sort((a, b) => new Date(a.next_charge_scheduled_at) - new Date(b.next_charge_scheduled_at));
    sortedSubscriptions.forEach(subscription => {
      this.querySelector('[data-next-prepaid-subscription]').innerHTML +=  this.createNextPrepaidSubscriptionOrderHTML(subscription);
    });
    console.log("✅ getNextPrepaidSubscriptionOrder Completed");
  }

  createNextPrepaidSubscriptionOrderHTML(subscription) {
    // const chargeData = await recharge.charge.listCharges(window.rechargeSession,{purchase_item_id:subscription.id});
    const productData = window.getProductById(subscription.external_product_id.ecommerce);
    
    if(productData == null){
      return '';
    }
    return `
      <single-prepaid-subscription class="block next-prepaid-subscription-order rounded-3 mb-4 lg:mb-5" data-subscription-id="733153799">
        <div class="next-sub-image rounded-3 overflow-hidden pt-2 pb-2 ps-2 pe-2 lg:pt-4 lg:pb-4 lg:ps-4 lg:pe-4">
              <img src="${productData.featured_image}?v=1764287068&width=200" alt="${productData.title}" height="200" width="200" class="mt-0 mb-0 rounded-3">
          </div>
          <div class="nex-sub-details">
            <div class="flex items-center gap-2 mb-2 lg:mb-3">
             <span class="lg:text-2xl text-xl font-bold uppercase leading-tighter heading tracking-none">${productData.title}</span>
            </div>
            <div class="flex items-center gap-2 mb-2 lg:mb-3">
              <span class="account-tag tag-primary breq-select-type font-medium">Prepaid</span>
            </div>
            <div class="flex items-center gap-2 mb-2 lg:mb-3">
              <span class="font-medium lg:text-xl text-lg tracking-none leading-tight"> Every ${subscription.order_interval_frequency} ${subscription.order_interval_unit}</span>
            </div>
            <div class="flex items-center gap-2 mb-2 lg:mb-3">
              <span data-next-charge-data></span>
            </div>
          </div>
      </single-prepaid-subscription>
    `;
  }

  async renderDiscoverCoffees() {
    console.log("🔥 renderDiscoverCoffees");
    const defaultPlaylistWrapper = document.querySelector('[data-default-playlist-wrapper]');
    if(defaultPlaylistWrapper == null){
      return;
    }
   if(this.activeBundleSubscriptions.length > 0){
      const sortedSubscriptions = [...this.activeBundleSubscriptions].sort((a, b) => new Date(a.next_charge_scheduled_at) - new Date(b.next_charge_scheduled_at));
      const currentBundleSubscription = sortedSubscriptions[0];
      const currentPlaylist = await window.playlistUtilities.getPlaylistDataByBundleProductId(currentBundleSubscription.include.bundle_product.external_product_id);
      const subscriptionPropeties = currentBundleSubscription.properties;
      let subsscriptonProperties = null;
      if(subscriptionPropeties.find(property => property.name == '_subscriptionData' || property.name == 'subscriptionData')){
        subsscriptonProperties = JSON.parse(subscriptionPropeties.find(property => property.name == '_subscriptionData' || property.name == 'subscriptionData').value);
      }
      else{
        subsscriptonProperties = subscriptionPropeties;
      }
      let espressoCount = parseInt(subsscriptonProperties.find(property => property.name == 'espresso')?.value);
      let filterCount = parseInt(subsscriptonProperties.find(property => property.name == 'filter')?.value);
      if(espressoCount == 0 && filterCount == 0){
        const {filter:filterCountFromSubscription,espresso:espressoCountFromSubscription} = window.subscriptionHelper.getFilterAndEspressoCountFromSubscription(currentBundleSubscription);
        espressoCount = espressoCountFromSubscription;
        filterCount = filterCountFromSubscription;
      }
      const totalCount = espressoCount + filterCount;
      defaultPlaylistWrapper.querySelectorAll('[data-playlist-name]').forEach(item => {
        item.classList.remove('hidden');
      });
      window.all_playlists.forEach(playlist => {
        const playlistItem = defaultPlaylistWrapper.querySelector(`[data-playlist-name="${playlist.playlist_handle}"]`);
        if(playlistItem && currentPlaylist){
          if(playlist.playlist_handle == currentPlaylist.playlist_handle){
            playlistItem.classList.add('hidden');
          }
            playlistItem.espressoCount = espressoCount;
            playlistItem.filterCount = filterCount;
            playlistItem.totalCount = totalCount;
            playlistItem.subscriptionData = currentBundleSubscription;
            playlistItem.frequency = currentBundleSubscription.order_interval_frequency;
            playlistItem.renderSwapPlaylistdata();
          }
      });
    }
    else{
      window.all_playlists.forEach(playlist => {
        const playlistItem = defaultPlaylistWrapper.querySelector(`[data-playlist-name="${playlist.playlist_handle}"]`);
        if(playlistItem){
            playlistItem.classList.remove('hidden');
            playlistItem.querySelectorAll('[data-default-swap-playlist]').forEach(item => {
              item.classList.add('subscribe-to-playlist');
              item.querySelector('.btn-text').textContent = 'Subscribe to this Playlist';
            });
          }
      });
    }
    console.log("✅ renderDiscoverCoffees Completed")
  }

  async renderCuratedPlaylists() {
    try{
    const curatedPlaylistsWrapper = this.querySelector('[data-curated-playlists-wrapper]');
    if(curatedPlaylistsWrapper == null){
      return;
    }
    const activeBundleSubscription = this.activeBundleSubscriptions[0];
    console.log(activeBundleSubscription,"thisactiveBundleSubscription");
      if(activeBundleSubscription){
        try{
          const current_playlist_handle = activeBundleSubscription.properties.find(property => property.name == 'playlist_handle')?.value;
          let totalQuantity = 0;
          activeBundleSubscription.include.bundle_selections?.items.forEach(item => {
            totalQuantity = totalQuantity + parseInt(item.quantity);
          });
          const bundleCount = totalQuantity;
          console.log(bundleCount,"bundleCount");
          const sellingPlanName = activeBundleSubscription.order_interval_frequency;
          const all_curated_playlists = window.all_playlists.filter(playlist => playlist.is_curated_playlist == true);
          if(bundleCount){
            all_curated_playlists.forEach(playlist => {
              const { bundleSelections, bundleObject, bundleProduct, playlistData, totalProductPrice, selectionProductListing, discountedPrice }= window.playlistUtilities.curatedStaticSelection(playlist.playlist_handle, bundleCount,String(sellingPlanName));
              
              const curatedPlaylistElement = curatedPlaylistsWrapper.querySelector(`[data-curated-playlist="${playlist.playlist_handle}"]`);
              if(curatedPlaylistElement == null){
                return;
              }
              if(playlist.playlist_handle == current_playlist_handle){
                curatedPlaylistElement.classList.add('hidden');
                return;
              }
              curatedPlaylistElement.bundleSelections = bundleSelections;
              curatedPlaylistElement.bundleObject = bundleObject;
              curatedPlaylistElement.bundleProduct = bundleProduct;
              curatedPlaylistElement.playlistData = playlistData;
              curatedPlaylistElement.totalProductPrice = totalProductPrice;
              curatedPlaylistElement.selectionProductListing = selectionProductListing;
              curatedPlaylistElement.discountedPrice = discountedPrice;
              curatedPlaylistElement.subscriptionData = activeBundleSubscription;
              curatedPlaylistElement.querySelectorAll('[data-discounted-price]').forEach(item => {
                item.innerHTML = theme.Currency.formatMoney(parseInt(discountedPrice), theme.settings.moneyFormat);
              });
              curatedPlaylistElement.querySelectorAll('[data-playlist-frequency]').forEach(item => {
                item.textContent = String(sellingPlanName);
              });
              if(playlist.playlist_handle == current_playlist_handle){
                const allSwapButtons = curatedPlaylistElement.querySelectorAll('[data-swape-curated-playlist]');
                allSwapButtons.forEach(item => {
                  item.classList.add('disabled');
                  item.setAttribute('disabled', true);
                });
              }
              if(curatedPlaylistElement){
                const productContents = curatedPlaylistElement.querySelectorAll('.account-dashboard-product-content');
                productContents.forEach((item,index) => {
                  if(index < bundleCount){
                    item.classList.remove('hidden');
                  }
                });
              }
            });
          }
        }
        catch(error){
          console.log(error,"error");
          const curatedPlaylistElement = curatedPlaylistsWrapper.querySelector(`[data-curated-playlist="${playlist.playlist_handle}"]`);
          curatedPlaylistElement.classList.add('hidden');
        }
      }
      else{
        if(curatedPlaylistsWrapper){
          curatedPlaylistsWrapper.classList.add('hidden');
        }
      }
    } 
    catch(error){
      const curatedPlaylistsWrapper = this.querySelector('[data-curated-playlists-wrapper]');
      if(curatedPlaylistsWrapper){
        curatedPlaylistsWrapper.classList.add('hidden');
      }
      console.error("🚨 Error sending request:", error.message);
    }
    console.log("✅ renderCuratedPlaylists Completed")
  }

  updateDiscoverCoffeesHTML(playlistItem,bundleSelections,bundleObject,playlistData,totalProductPrice,selectionProductListing,discountedPrice,bundleProduct,sellingPlan,subscriptionData) {
    if(playlistItem){
      playlistItem.querySelectorAll('[data-discounted-price]').forEach(item => {
        item.innerHTML = theme.Currency.formatMoney(parseInt(discountedPrice), theme.settings.moneyFormat);
      });
      playlistItem.querySelectorAll('[data-playlist-frequency]').forEach(item => {
        item.textContent = subscriptionData.order_interval_frequency;
      });
      playlistItem.querySelector('[data-playlist-carousel]').innerHTML = '';
      selectionProductListing.forEach(item => {
        playlistItem.querySelector('[data-playlist-carousel]').innerHTML += this.createProductHTML(item);
      });
    }
  }
  createProductHTML(item) {
    return `
      <div class="account-dashboard-product-content" data-add-onetime-product data-product-id="${item.id}">
          <img src="${item.images[0].small}" alt="${item.title}" height="150" width="150" class="mt-0 mb-2 w-full">
          <div class="text-sm font-bold leading-tight tracking-none heading mb-1"> ${item.title} </div>
          <p class="text-xs mt-0 mb-0"> ${item.variants.find(variant => variant.title == "300g" || variant.title == "300G" || variant.title == "300 G" || variant.title == "300 g").title} adawdw</p>
      </div>
    `;
  }

  async setAddressData() {
    const customerAddressContentElement = this.querySelector('[data-customer-address-content]');
    const defaultAddress = this.customerData.include.addresses.length > 0 ? this.customerData.include.addresses[0] : null;
    if(customerAddressContentElement){
      customerAddressContentElement.querySelector('[data-customer-full-name]').innerHTML = this.customerData.first_name ? this.customerData.first_name + ' ' + this.customerData.last_name : this.customerData.last_name ? this.customerData.last_name : '';
      customerAddressContentElement.querySelector('[data-customer-email]').innerHTML = this.customerData.email ? this.customerData.email : '-';
      customerAddressContentElement.querySelector('[data-customer-phone]').innerHTML = this.customerData.phone ? this.customerData.phone : '-';
      if(defaultAddress){
        customerAddressContentElement.querySelector('[data-default-address-edit]').setAttribute('data-address-id', defaultAddress.id);
      }
    }
    this.querySelector('[data-manage-address-button]').addEventListener('click',() => {
      
      this.manageAddressAction = 'address'
      this.querySelector('[data-customer-manage-address-content]').classList.remove('hidden');
      this.querySelector('[data-customer-manage-payment-content]').classList.add('hidden');
      this.querySelector('[data-manage-address-payment-content]').classList.add('hidden');
      customerAddressContentElement.classList.add('hidden');
    });
    this.querySelector('[data-manage-payment-button]').addEventListener('click',() => {
      this.manageAddressAction = 'payment'
      this.querySelector('[data-customer-manage-payment-content]').classList.remove('hidden');
      this.querySelector('[data-customer-manage-address-content]').classList.add('hidden');
      this.querySelector('[data-manage-address-payment-content]').classList.add('hidden');
      customerAddressContentElement.classList.add('hidden');
    });

    this.querySelector('[data-address-payment-action]').addEventListener('click',() => {
      this.querySelector('[data-address-payment-action]').classList.add('account-button-active-border');
      this.querySelector('.account-dashboard__tabs').classList.add('payment-address-tab-opend');
      this.manageAddressAction = 'address_payment'
      this.querySelector('[data-address-payment-content]').classList.remove('hidden');
      this.querySelector('[data-main-content-tab]').classList.add('hidden');
      customerAddressContentElement.classList.remove('hidden');
    });
    this.querySelector('[data-address-payment-back-action]').addEventListener('click',() => {
      
      console.log(this.manageAddressAction,"this.manageAddressAction");
      if(this.manageAddressAction == 'address'){
        this.querySelector('[data-customer-manage-address-content]').classList.add('hidden');
        this.querySelector('[data-customer-address-content]').classList.remove('hidden');
        this.querySelector('[data-manage-address-payment-content]').classList.remove('hidden');
        this.manageAddressAction = 'address_payment';
      }else if(this.manageAddressAction == 'payment'){
        this.querySelector('[data-customer-manage-payment-content]').classList.add('hidden');
        this.querySelector('[data-customer-address-content]').classList.remove('hidden');
        this.manageAddressAction = 'address_payment';
        this.querySelector('[data-manage-address-payment-content]').classList.remove('hidden');
      }
      else if(this.manageAddressAction == 'address_payment'){
        this.querySelector('[data-address-payment-action]').classList.remove('account-button-active-border');
        this.querySelector('.account-dashboard__tabs').classList.remove('payment-address-tab-opend');
        this.querySelector('[data-address-payment-content]').classList.add('hidden');
        this.querySelector('[data-main-content-tab]').classList.remove('hidden');
        
        this.querySelector('[data-manage-address-payment-content]').classList.remove('hidden');
      }
    });
    this.querySelector('[data-add-new-drawer-open]').addEventListener('click',() => {
      const addAddressDrawer = document.querySelector('add-address-drawer');
      addAddressDrawer.show();
    });
    this.querySelector('[data-manage-subscription-button]').addEventListener('click',() => {
      const nextSubscriptionOrder = document.querySelectorAll('next-subscription-order');

      // if(nextSubscriptionOrder.isWithinSevenDays == false){
      //   window.notificationEle.updateNotification('Update Subscription', 'You can update your subscription details within 7 days of your next order', {
      //     type: 'info',
      //     timeout: 10000
      //   });       
      //   return;
      // }
      if(nextSubscriptionOrder.length > 0){
        if(nextSubscriptionOrder[0]){
          nextSubscriptionOrder[0].querySelector('[aria-controls="Subscription-edit-modal"]').click();
          const subscriptionEditModal = document.getElementById('Subscription-edit-modal');
          subscriptionEditModal.noDecaf = nextSubscriptionOrder[0].noDecaf;
        }
        
      }
      else{
        window.notificationEle.updateNotification('Playlist', 'No Playlist Found', {
          type: 'info',
          timeout: 10000
        });
      }
    });
    this.renderAddressesList();
    console.log("✅ setAddressData Completed")
  }
  async renderPaymentMethods() {
    const paymentMethodsElement = this.querySelector('[data-payment-methods-listing]');
    paymentMethodsElement.innerHTML = '';
    const addresses = this.customerData.include.addresses
    this.customerData.include.payment_methods.forEach(paymentMethod => {
      if(addresses.find(address => address.payment_method_id === paymentMethod.id)){
        const addresId = addresses.find(address => address.payment_method_id === paymentMethod.id).id;
        paymentMethodsElement.innerHTML += this.createPaymentMethodsHTML(paymentMethod,addresId);
      }
    });
   

    this.querySelectorAll("[data-payment-method-edit-button]").forEach(
      (item) => {
        item.addEventListener("click", async (e) => {
          e.preventDefault();
          item.setAttribute('disabled', true);
          item.setAttribute('aria-disabled', true);
          item.setAttribute('aria-busy', true);
          const paymentMethodId = parseInt(
            item.getAttribute("data-payment-method-id"),
            10
          );
          const addressId = parseInt(
            item.getAttribute("data-address-id"),
            10
          );
          try {
            await recharge.customer.sendCustomerNotification(
              window.rechargeSession,
              "SHOPIFY_UPDATE_PAYMENT_INFO",
              {
                address_id: addressId,
                payment_method_id: paymentMethodId,
              }
            );
            window.notificationEle.updateNotification('Payment Method', 'Email has been sent to your email to update the payment method', {
              type: 'success',
              timeout: 10000
            });
          } catch (error) {
            console.log(error,"error");
            item.removeAttribute('disabled');
            item.removeAttribute('aria-disabled');
            item.removeAttribute('aria-busy');
          }
          finally{
            item.removeAttribute('disabled');
            item.removeAttribute('aria-disabled');
            item.removeAttribute('aria-busy');
          }
        });
      }
    );
    console.log("✅ renderPaymentMethods Completed")
  }
  async renderAddressesList() {
    const addressesListElement = this.querySelector('[data-addresses-list]');
    addressesListElement.innerHTML = '';
    this.customerData.include.addresses.forEach(address => {
      addressesListElement.innerHTML += this.createAddressesListHTML(address);
    });
    this.querySelectorAll('[data-address-edit-button]').forEach(item => {
      item.addEventListener('click',(event) => {
        let addressId = null;
        let address = null;
        if(event.currentTarget.getAttribute('data-address-id')){
          addressId = event.currentTarget.getAttribute('data-address-id');
          address = this.customerData.include.addresses.find(address => address.id == addressId);
        }
        else{
          addressId = event.target.closest('button').getAttribute('data-address-id');
          address = this.customerData.include.addresses.find(address => address.id == addressId);
        }
        const addressEditPanel = document.getElementById('Address-edit');
        addressEditPanel.addressObject = address;
        addressEditPanel.renderAddressData();
        addressEditPanel.show();
      });
    });
    this.querySelectorAll('[data-default-address-edit]').forEach(item => {
      item.addEventListener('click',(event) => {
        let addressId = null;
        let address = null;
        if(event.currentTarget.getAttribute('data-address-id')){
          addressId = event.currentTarget.getAttribute('data-address-id');
          address = this.customerData.include.addresses.find(address => address.id == addressId);
        }
        else{
          addressId = event.target.closest('button').getAttribute('data-address-id');
          address = this.customerData.include.addresses.find(address => address.id == addressId);
        }
        const addressEditPanel = document.getElementById('Address-edit');
        addressEditPanel.addressObject = address;
        addressEditPanel.renderAddressData();
        addressEditPanel.show();
      });
    });
    this.querySelectorAll('[data-edit-address-remove-button]').forEach(item => {
      item.addEventListener('click',async () => {
        const addressId = parseInt(
          item.getAttribute("data-address-id"),
          10
        );
        item.setAttribute('disabled', true);
        item.setAttribute('aria-disabled', true);
        item.setAttribute('aria-busy', true);
        try {
          await recharge.address.deleteAddress(window.rechargeSession, addressId);
          window.notificationEle.updateNotification('Address', 'Address has been deleted successfully', {
            type: 'success',
            timeout: 10000
          });
          document.dispatchEvent(new CustomEvent('update:subscriptionDashboard'));
        } catch (error) {
          if(error.status == 422){
            window.notificationEle.updateNotification('Address can’t be deleted', 'This address is currently associated with one or more subscriptions. Please update your subscriptions to use a different address before removing this one', {
              type: 'error',
              timeout: 10000
            });
          }
          console.log(error,"error");
        }
        finally{
          item.removeAttribute('disabled');
          item.removeAttribute('aria-disabled');
          item.removeAttribute('aria-busy');
          
        }
      });
    });
  }
  createAddressesListHTML(address) {
    return `
      <div class="edit-address-content flex flex-col md:flex-row md:justify-between md:items-center pt-4 pb-4 ps-4 pe-4 lg:pt-5 lg:pb-5 lg:ps-5 lg:pe-5 rounded-3 mb-4 lg:mb-5">
        <div class="mb-4 lg:mb-0">
          <p class="mt-0 mb-2 lg:text-lg text-base leading-normal font-bold capitalize cccc">${address.first_name} ${address.last_name}</p>
          <p class="mt-0 mb-0 lg:text-base text-sm leading-normal">
            ${address.address1 ? address.address1 : ''} <br>
            ${address.city ? address.city : ''} <br>
            ${address.province ? address.province : ''} <br>
            ${address.zip ? address.zip : ''}
          </p>
        </div>
        <div class="flex items-center gap-3">
          <button
            class="button button--secondary gap-3 icon-with-text edit-address-button w-full lg:w-auto"
            role="link"
            aria-disabled="true"
            is="hover-button"
            data-address-edit-button
            data-address-id="${address.id}"
          >
            <span class="btn-fill" data-fill></span>
            <span class="btn-text max-w-max">
              <svg class="icon icon-edit-playlist icon-sm transform" viewBox="0 0 17 17" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.4707 15.5294L2.44011 11.6518L13.1436 0.948242L16.0519 3.85648L5.34835 14.56L1.4707 15.5294Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M10.5 4L13 6.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            Edit
            </span>
          </button>
          <button
            data-edit-address-remove-button
            class="button button--secondary gap-3 icon-with-text edit-address-button w-full lg:w-auto"
            role="link"
            aria-disabled="true"
            is="hover-button"
            data-address-id="${address.id}"
          >
            <span class="btn-fill" data-fill></span>
            <span class="btn-text max-w-max">
              <svg class="icon icon-delete icon-sm transform" viewBox="0 0 18 18" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.6476 4.29419L13.8382 14.7883C13.7629 15.7671 12.9441 16.5295 11.9653 16.5295H6.03587C5.04763 16.5295 4.23822 15.7765 4.16293 14.7883L3.35352 4.29419" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M1.4707 4.29419H16.5295" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M7.11719 4.29423V2.41188C7.11719 1.89423 7.54072 1.4707 8.05836 1.4707H9.94072C10.4584 1.4707 10.8819 1.89423 10.8819 2.41188V4.29423" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M7.11719 12.765V8.05908" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M10.8828 12.765V8.05908" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              Remove
            </span>
          </button>
        </div>
      </div>
    `;
  }
  createNextSubscriptionOrderHTML(subscription) {
    return `
    <div data-charge-error-message class="charge-error-message"></div>
      <next-subscription-order data-subscription-id="${subscription.id}" data-subscription-address-id="${subscription.address_id}" class="next-subscription-order pt-5 pb-5 ps-5 pe-5 lg:pt-7 lg:pb-7 lg:ps-7 lg:pe-7 next-order-box rounded-3 mb-4 lg:mb-5 block">
      </next-subscription-order>
    `;
  }
  createPaymentMethodsHTML(paymentMethod,addressId) {
    return `
      <div class="edit-address-content flex flex-col md:flex-row md:justify-between md:items-center pt-4 pb-4 ps-4 pe-4 lg:pt-5 lg:pb-5 lg:ps-5 lg:pe-5 rounded-3 mb-4 lg:mb-5">
        <div class="mb-4 lg:mb-0">
            <div class="flex items-center gap-3 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="28" viewBox="0 0 40 28" fill="none">
                    <rect x="0.5" y="0.5" width="39" height="27" rx="2.5" fill="white" stroke="#D9D9D9"></rect>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1427 18.968H9.71948L7.90235 11.8911C7.81611 11.5656 7.63298 11.2778 7.3636 11.1422C6.69133 10.8013 5.95054 10.53 5.14241 10.3932V10.1208H9.04603C9.58479 10.1208 9.98886 10.53 10.0562 11.0054L10.999 16.1101L13.4211 10.1208H15.7769L12.1427 18.968ZM17.1235 18.9678H14.835L16.7194 10.1206H19.008L17.1235 18.9678ZM21.9684 12.5715C22.0357 12.095 22.4398 11.8225 22.9112 11.8225C23.652 11.7541 24.459 11.8909 25.1324 12.2306L25.5365 10.3258C24.863 10.0533 24.1222 9.9165 23.45 9.9165C21.2288 9.9165 19.6125 11.142 19.6125 12.8428C19.6125 14.1367 20.7574 14.816 21.5655 15.2253C22.4398 15.6334 22.7765 15.9059 22.7092 16.314C22.7092 16.9261 22.0357 17.1986 21.3635 17.1986C20.5553 17.1986 19.7472 16.9945 19.0076 16.6537L18.6035 18.5597C19.4117 18.8994 20.2859 19.0362 21.0941 19.0362C23.5847 19.1034 25.1324 17.8791 25.1324 16.0415C25.1324 13.7274 21.9684 13.5917 21.9684 12.5715ZM33.1421 18.968L31.3249 10.1208H29.3731C28.9691 10.1208 28.565 10.3932 28.4303 10.8013L25.0654 18.968H27.4213L27.8915 17.6753H30.7862L31.0556 18.968H33.1421ZM29.7102 12.5029L30.3824 15.8372H28.498L29.7102 12.5029Z"
                    fill="#172B85"></path>
                </svg>
                <p class="mt-0 mb-0 lg:text-lg text-base leading-normal font-bold capitalize">${paymentMethod.payment_details.brand} ****${paymentMethod.payment_details.last4}</p>
                <p class="mt-0 mb-0 lg:text-sm text-2sm leading-normal capitalize">Exp ${paymentMethod.payment_details.exp_month}/${paymentMethod.payment_details.exp_year}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:items-center lg:text-base text-sm capitalize leading-normal tracking-none mb-2 billing-address-box">
                <p class="font-bold">Billing Address:</p>
                <p>${paymentMethod.billing_address.address1 ? paymentMethod.billing_address.address1 : ''} ${paymentMethod.billing_address.city ? paymentMethod.billing_address.city : ''} ${paymentMethod.billing_address.province ? paymentMethod.billing_address.province : ''} ${paymentMethod.billing_address.zip ? paymentMethod.billing_address.zip : ''}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:items-center lg:text-base text-sm capitalize leading-normal tracking-none billing-address-box hidden">
                <p class="font-bold">Shipping Address:</p>
                <p></p>
            </div>
        </div>
        <div class="flex items-center gap-3" >
            <button class="button button--secondary gap-3 icon-with-text edit-address-button w-full lg:w-auto" role="link" aria-disabled="true" is="hover-button" data-payment-method-edit-button data-address-id="${addressId}" data-payment-method-id="${paymentMethod.id}">
                <span class="btn-fill" data-fill=""></span>
                <span class="btn-text max-w-max"><svg class="icon icon-edit-playlist icon-sm transform" viewBox="0 0 17 17" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.4707 15.5294L2.44011 11.6518L13.1436 0.948242L16.0519 3.85648L5.34835 14.56L1.4707 15.5294Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M10.5 4L13 6.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>Edit</span>
                <span class="btn-loader">
                <span></span>
                <span></span>
                <span></span>
                </span>
            </button>
        </div>
    </div>
    `;
  }

}

// Register the custom element
customElements.define('recharge-dashboard', RechargeDashboard);

class NextSubscriptionOrder extends HTMLElement {
  constructor() {
    super();
    this.noDecaf = false;
    this.isDecafUpdating = false;
  }
  connectedCallback() {
    this.getNextOrderData();
  } 
  async getNextOrderData() {
    this.subscription_id = parseInt(this.getAttribute('data-subscription-id'));
    this.rechargeDashboard = document.querySelector('recharge-dashboard');
    this.subscription_address_id = parseInt(this.getAttribute('data-subscription-address-id'));
    this.chargeData = this.rechargeDashboard.queuedChargesData.find(charge => charge.address_id == this.subscription_address_id);
    this.errorChargesResponse = await recharge.charge.listCharges(window.rechargeSession,{purchase_item_id:this.subscription_id,status:"error"});
    this.errorChargesData = this.errorChargesResponse.charges;
    this.errorForNextCharge = false;
    this.subscription = this.rechargeDashboard.activeBundleSubscriptions.find(subscription => subscription.id == this.subscription_id);
    this.decafe = false;
    if(this.errorChargesData.length > 0){
      this.errorCharge = this.errorChargesData[0];
      this.errorForNextCharge = true;
    }
    else{
      this.errorCharge = null;
    }
    if(this.subscription){
      this.renderNextSubscriptionOrder(this.chargeData,this.subscription,this.errorCharge);
    }
  }
  initEvents(){
    this.querySelectorAll('[data-current-order-decaf-info]').forEach(item => {
      item.querySelector('.upcoming-order-decaf-toggle')?.addEventListener('change', async () => {
        const toggle = item.querySelector('.upcoming-order-decaf-toggle');

        if (this.isDecafUpdating) {
          toggle.checked = !toggle.checked;
          return;
        }

        const previousChecked = !toggle.checked;
        this.noDecaf = toggle.checked;
        this.isDecafUpdating = true;
        toggle.disabled = true;
        item.setAttribute('aria-busy', 'true');

        try {
          await this.swapeSubscriptionFromProperties(this.subscription,this.noDecaf);
          document.dispatchEvent(new CustomEvent('update:subscriptionDashboard'));
        } catch (error) {
          console.error(error);
          toggle.checked = previousChecked;
          this.noDecaf = toggle.checked;
          window.notificationEle.updateNotification('No Decaf', 'Something went wrong updating your subscription', {
            type: 'error',
            timeout: 10000
          });
        } finally {
          this.isDecafUpdating = false;
          toggle.disabled = false;
          item.removeAttribute('aria-busy');
        }
      });
    });
    this.querySelectorAll('[aria-controls="Address-edit"]').forEach(item => {
      item.addEventListener('click',async () => {
        item.setAttribute('aria-expanded', 'true');
        const addressEditPanel = document.getElementById('Address-edit');
        addressEditPanel.addressObject = this.subscription.include.address;
        console.log("addressEditPanel Clicked")
        addressEditPanel.renderAddressData();
        await addressEditPanel.show();
      });
    });
    this.querySelectorAll('[aria-controls="Apply-discount"]').forEach(item => {
      item.addEventListener('click',async () => {
        // if(this.isWithinSevenDays == false){
        //   window.notificationEle.updateNotification('Update Subscription', 'You can update your subscription details within 7 days of your next order', {
        //     type: 'info',
        //     timeout: 10000
        //   });       
        //   return;
        // }
        item.setAttribute('aria-expanded', 'true');
        const discountEditPanel = document.getElementById('Apply-discount');
        discountEditPanel.address_id = this.subscription.address_id;

        await discountEditPanel.show();
      });
    });
    this.querySelectorAll('[aria-controls="Skip-order"]').forEach(item => {
      item.addEventListener('click',async () => {
        // if(this.isWithinSevenDays == false){
        //   window.notificationEle.updateNotification('Update Subscription', 'You can update your subscription details within 7 days of your next order', {
        //     type: 'info',
        //     timeout: 10000
        //   });       
        //   return;
        // }
        item.setAttribute('aria-expanded', 'true');
        item.setAttribute('aria-disabled', 'true');
        item.setAttribute('aria-busy', 'true');
        const skipOrderPanel = document.getElementById('Skip-order');
        skipOrderPanel.subscriptionData = this.subscription;
        skipOrderPanel.chargeData = this.chargeData;
        skipOrderPanel.renderData();
        await skipOrderPanel.show();
        setTimeout(() => {
          item.setAttribute('aria-disabled', 'false');
          item.setAttribute('aria-busy', 'false');
        }, 200);
      });
    });
    this.querySelectorAll('[aria-controls="Subscription-edit-modal"]').forEach(item => {
      item.addEventListener('click',async () => {
        // if(this.isWithinSevenDays == false){
        //   window.notificationEle.updateNotification('Update Subscription', 'You can update your subscription details within 7 days of your next order', {
        //     type: 'info',
        //     timeout: 10000
        //   });       
        //   return;
        // }
        item.setAttribute('aria-expanded', 'true');
        const subscriptionEditModal = document.getElementById('Subscription-edit-modal');
        item.setAttribute('aria-expanded', 'true');
        item.setAttribute('aria-disabled', 'true');
        item.setAttribute('aria-busy', 'true');
        subscriptionEditModal.playlistData = this.playlistData;
        subscriptionEditModal.subscriptionData = this.subscription;
        if(this.errorForNextCharge){
          subscriptionEditModal.subscriptionCharges = this.errorCharge;
        }
        else{
          subscriptionEditModal.subscriptionCharges = this.chargeData;
        }
        subscriptionEditModal.renderPlaylistData();
        subscriptionEditModal.onSwitchToSwapPlaylistButtonClick();
        subscriptionEditModal.onSwapPlaylistBackButtonClick();
        await subscriptionEditModal.show();
        setTimeout(() => {
          item.setAttribute('aria-disabled', 'false');
          item.setAttribute('aria-busy', 'false');
          item.setAttribute('aria-expanded', 'false');
        }, 200);
      });
    });
    this.querySelectorAll('[aria-controls="swap-playlist-trigger"]').forEach(item => {
      item.addEventListener('click',async () => {
        // if(this.isWithinSevenDays == false){
        //   window.notificationEle.updateNotification('Update Subscription', 'You can update your subscription details within 7 days of your next order', {
        //     type: 'info',
        //     timeout: 10000
        //   });       
        //   return;
        // }
        item.setAttribute('aria-expanded', 'true');
        item.setAttribute('aria-disabled', 'true');
        item.setAttribute('aria-busy', 'true');
        const subscriptionEditModal = document.getElementById('Subscription-edit-modal');
        
        subscriptionEditModal.playlistData = this.playlistData;
        subscriptionEditModal.subscriptionData = this.subscription;
        subscriptionEditModal.noDecaf = this.noDecaf;
        if(this.playlistData.is_curated_playlist){
          subscriptionEditModal.classList.add('curated-swap-playlist-opened')
        }
        else{
          subscriptionEditModal.classList.remove('curated-swap-playlist-opened')
        }
        if(this.errorForNextCharge){
          subscriptionEditModal.subscriptionCharges = this.errorCharge;
        }
        else{
          subscriptionEditModal.subscriptionCharges = this.chargeData;
        }
        subscriptionEditModal.renderPlaylistData();
        subscriptionEditModal.onSwitchToSwapPlaylistButtonClick();
        await subscriptionEditModal.show();
        setTimeout(() => {
          item.setAttribute('aria-disabled', 'false');
          item.setAttribute('aria-busy', 'false');
          item.setAttribute('aria-expanded', 'false');
        }, 200);
      });
    });
    this.querySelector('[data-apply-credit-next-order]').addEventListener('click',async (e) => {
      e.preventDefault();
      if(this.querySelector('[data-apply-credit-next-order]').classList.contains('checked')){
        this.querySelector('[data-apply-credit-next-order]').classList.remove('checked');
        const updatedCustomerData = await recharge.credit.setApplyCreditsToNextCharge(
          window.rechargeSession,
          // Control whether credits should only be applied to recurring charges
          { recurring: false }
        );
        this.rechargeDashboard.customerData = updatedCustomerData;
        this.classList.add('checked')
      }else{
        this.querySelector('[data-apply-credit-next-order]').classList.add('checked');
        const updatedCustomerData = await recharge.credit.setApplyCreditsToNextCharge(
          window.rechargeSession,
          // Control whether credits should only be applied to recurring charges
          { recurring: true }
        );
        this.rechargeDashboard.customerData = updatedCustomerData;
        this.classList.add('checked')
      }
    })
    if(this.querySelector('[aria-controls="schedule-next-order"')){
      this.querySelector('[aria-controls="schedule-next-order"]').addEventListener('click',async (e) => {
        e.preventDefault();
        const scheduleNextOrderPanel = document.getElementById('schedule-next-order');
        scheduleNextOrderPanel.chargeData = this.chargeData;
        scheduleNextOrderPanel.subscriptionData = this.subscription;
        scheduleNextOrderPanel.renderData();
        await scheduleNextOrderPanel.show();
      })
    }
    if(this.querySelector('[data-add-on-button]')){
      this.querySelector('[data-add-on-button]').addEventListener('click',async (e) => {
        e.preventDefault();
        if(window.allProducts.length == 0){
          await window.getAllProducts(); 
        }
        const oneTimeDrawer = document.querySelector('add-on-one-time-drawer');
        if(oneTimeDrawer){
          oneTimeDrawer.subscription_id = this.subscription_id;
          oneTimeDrawer.subscriptionData = this.subscription;
          oneTimeDrawer.chargeData = this.chargeData;
          oneTimeDrawer.show();
        }
      })
    }
    if(this.parentNode?.querySelector('[data-action-update-payment-method]')){
      this.parentNode?.querySelector('[data-action-update-payment-method]').addEventListener('click',async (e) => {
        e.preventDefault();
        const addressId = e.target.getAttribute('data-charge-addres-id');
        const rechargeDashboard = document.querySelector('recharge-dashboard');
        const customerData = rechargeDashboard.customerData;
        const addresses = customerData.include.addresses;
        const address = addresses.find(address => address.id == addressId);
        if(address){
          try{
          await recharge.customer.sendCustomerNotification(
            window.rechargeSession,
            "SHOPIFY_UPDATE_PAYMENT_INFO",
            {
              address_id: addressId,
              payment_method_id: address.payment_method_id || null,
            }
          );
          window.notificationEle.updateNotification('Update Payment Method', 'Email has been sent to your email to update the payment method', {
            type: 'success',
            timeout: 10000
          });
          } catch (error) {
            console.log(error,"error");
            window.notificationEle.updateNotification('Payment Method', 'Something went wrong', {
              type: 'error',
              timeout: 10000
            });
          }
        }
      })
    }
    if(this.parentNode?.querySelector('[data-action-retry-payment]')){
      this.parentNode?.querySelector('[data-action-retry-payment]').addEventListener('click',async (e) => {
        e.preventDefault();
        const chargeId = e.target.getAttribute('data-charge-id');
        try{
          await recharge.charge.processCharge(window.rechargeSession, chargeId);
          window.notificationEle.updateNotification('Retry Payment', 'Payment has been retried successfully', {
            type: 'success',
            timeout: 10000
          });
        } catch (error) {
          console.log(error,"error");
          window.notificationEle.updateNotification('Retry Payment', 'Something went wrong', {
            type: 'error',
            timeout: 10000
          });
        }
       
      })
    }
  }
  async swapeSubscriptionFromProperties(subscription,decaf){
    try{
    const excludeDecafe = decaf;

    const properties = subscription.properties;
    const playlistHandle = properties.find(property => property.name == 'playlist_handle')?.value;
    if(playlistHandle == null || playlistHandle != 'mixtape'){
      return;
    }
    const filterCount = properties.find(property => property.name == 'filter')?.value;
    const espressoCount = properties.find(property => property.name == 'espresso')?.value;
    const totalCount = filterCount + espressoCount;
    const frequency = subscription.order_interval_frequency;
    let bundleObjectDf = null;
    let selectionProductListingDF = [];
    try{
      const {bundleSelections,bundleObject,playlistData,totalProductPrice,selectionProductListing,discountedPrice,bundleProduct,sellingPlan,externalCollectionId} = window.playlistUtilities.getDynamicMultiPlaylistBundleSelection(playlistHandle,totalCount,{espresso:espressoCount,filter:filterCount},`${frequency} week`,excludeDecafe);
      bundleObjectDf = bundleObject;
      selectionProductListingDF = selectionProductListing;
      }
      catch(error){
        const {bundleSelections,bundleObject,playlistData,totalProductPrice,selectionProductListing,discountedPrice,bundleProduct,sellingPlan,externalCollectionId} = window.playlistUtilities.getDynamicBundleSelection(playlistHandle,totalCount,{espresso:espressoCount,filter:filterCount},`${frequency} week`,excludeDecafe);
        bundleObjectDf = bundleObject;
        selectionProductListingDF = selectionProductListing;
      }
      let grind_preference_array = [];
      let products_sku = [];
      const espressoBrewType = properties.find(property => property.name == 'grind_espresso')?.value;
      const filterBrewType = properties.find(property => property.name == 'grind_filter')?.value;
      selectionProductListingDF.forEach(item => {
        if(item.tags.includes('espresso')){
          item.variants.forEach(variant => {
            if(variant.title == "300g" || variant.title == "300G" || variant.title == "300 G" || variant.title == "300 g"){
              grind_preference_array.push({variantId:variant.id,grind_Value:espressoBrewType});
              products_sku.push({sku:variant.sku,grindType:espressoBrewType});
            }
          });
        }
        else{
          item.variants.forEach(variant => {
            if(variant.title == "300g" || variant.title == "300G" || variant.title == "300 G" || variant.title == "300 g"){
              grind_preference_array.push({variantId:variant.id,grind_Value:filterBrewType});
              products_sku.push({sku:variant.sku,grindType:filterBrewType});
            }
          });
        }
      });
        const newProperties = window.subscriptionHelper.updateProperties(properties, {decaf:String(!excludeDecafe),grind_preference_array:JSON.stringify(grind_preference_array),products_sku:JSON.stringify(products_sku)});
        console.log(bundleObjectDf,"bundleObjectDf");
        const finalBundleObject = window.playlistUtilities.convertBundleObjectToRechargeBundleObject(bundleObjectDf);
        console.log(finalBundleObject,"finalBundleObject");
        const isValid = await recharge.bundle.validateBundle(finalBundleObject);
        if(!isValid){
          window.notificationEle.updateNotification('Create Bundle Selection', 'Invalid Bundle', {
            type: 'info',
            timeout: 10000
          });
          return;
        }
        const response = await recharge.bundle.updateBundle(window.rechargeSession,subscription.id,finalBundleObject,{ order_interval_frequency: parseInt(frequency) },{ commit: true });
        console.log(response,"response");
        const response2 = await recharge.subscription.updateSubscription(window.rechargeSession,subscription.id,{properties:newProperties},{ commit: true });
        console.log(response2,"response2");
        const response3 = await recharge.address.updateAddress(window.rechargeSession,subscription.address_id,{
          order_attributes:
          [{name:'_subscriptionData',value:JSON.stringify(newProperties)}]
        });
      }
      catch(error){
        console.log(error,"error");
        return;
      }
    
  }
  dateToFormattedDate(dateStr) {
    let formattedDate = "";
    if (dateStr) {
      const date = new Date(dateStr);
      const day = date.getDate();
      const month = date.toLocaleString('en-US', { month: 'short' });
      const year = date.getFullYear();
      formattedDate = `${day} ${month} ${year}`;
    }
    return formattedDate;
  }
  renderNextSubscriptionOrder(charge,subscription,errorCharge) {
    let updatedCharge = charge;
    if(errorCharge){
      updatedCharge = errorCharge;
      this.isWithinSevenDays = true;
      this.rechargeDashboard.isWithinSevenDays = this.isWithinSevenDays;
    }
    else{
      this.isWithinSevenDays = window.isWithinSevenDays(charge.scheduled_at);
      this.rechargeDashboard.isWithinSevenDays = this.isWithinSevenDays;
      
      if(window.enableTestMode == 'true'){
        this.isWithinSevenDays = true;
        this.rechargeDashboard.isWithinSevenDays = this.isWithinSevenDays;
      }
    }
    
    const itemSubscription = subscription;
    const chargeSubscription = this.rechargeDashboard.activeBundleSubscriptions.find(subscription => subscription.id == this.subscription_id);
    const customerData = this.rechargeDashboard.customerData;
    const creditData = this.rechargeDashboard.creditData;
    
    if(chargeSubscription.include?.bundle_product == null){
      return
    }
    if(chargeSubscription.include?.bundle_selections == null){
      console.log("bundle_selections is null");
      this.innerHTML = this.renderCreateBundleSelectionHTML(chargeSubscription);
      this.createBundleEvent();
      return;
    }
    
    const bundleProductId = chargeSubscription.include.bundle_product.external_product_id;
    const nextPlaylistData = window.playlistUtilities.getPlaylistDataByBundleProductId(bundleProductId);
    this.playlistData = nextPlaylistData;
    if(nextPlaylistData){
      this.innerHTML = this.createNextSubscriptionOrderHTML(updatedCharge,chargeSubscription,itemSubscription,customerData,creditData,nextPlaylistData,this.isWithinSevenDays);
    }
    
    this.renderDecafInfo(itemSubscription);
    if(this.errorForNextCharge){ 
      if(this.previousElementSibling) {
        let formattedDate = "";
        switch(updatedCharge.error_type){
          case 'FRAUD_SUSPECTED':
            // Format "2025-11-16T02:06:03" to "16 Nov 2025"
              formattedDate = this.dateToFormattedDate(updatedCharge.last_charge_attempt_date);
              this.previousElementSibling.innerHTML = `
              <div class="product-form__error-message alert alert--error text-sm font-medium leading-tight" role="alert">
                <h4 class="mt-0">We couldn’t process your ${formattedDate} order</h4>
                <p>We’re having trouble with your account. Please contact us at <a href="mailto:orders@monogramcoffee.com">orders@monogramcoffee.com</a> to resolve.</p>
              </div>
              `;
            break;
          case 'PAYMENT_METHOD_DECLINED' || 'INVALID_PAYMENT_METHOD' || 'PAYMENT_METHOD_REQUIRED' || 'EXPIRED_PAYMENT_METHOD' || 'PAYMENT_METHOD_NOT_FOUND':
            formattedDate = this.dateToFormattedDate(updatedCharge.last_charge_attempt_date);
            this.previousElementSibling.innerHTML = `
              <div class="product-form__error-message alert alert--error text-sm font-medium leading-tight" role="alert">
                <h4 class="mt-0">We couldn’t process your ${formattedDate} order</h4>
                <div class="flex flex-col gap-2">
                  <p>We’re having trouble with your account. Please contact us at <a href="mailto:orders@monogramcoffee.com">orders@monogramcoffee.com</a> to resolve.</p>
                  <p>Please Update your payment method or retry the payment.</p>
                </div>
                <button data-action-update-payment-method data-charge-addres-id="${updatedCharge.address_id}" class="button button--primary w-full next-order-button icon-with-text" role="link" aria-disabled="true" is="hover-button">
                  <span class="btn-fill" data-fill="" style="transform: translateY(var(--motion-translateY)); --motion-translateY: -76%;"></span>
                  <span class="btn-text max-w-max uppercase">
                    Update Payment Method
                  </span>
                  <span class="btn-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                </button>
                <button data-action-retry-payment data-charge-addres-id="${updatedCharge.address_id}" data-charge-id="${updatedCharge.id}" class="button button--primary w-full next-order-button icon-with-text" role="link" aria-disabled="true" is="hover-button">
                  <span class="btn-fill" data-fill="" style="transform: translateY(var(--motion-translateY)); --motion-translateY: -76%;"></span>
                  <span class="btn-text max-w-max uppercase">
                    Retry Payment
                  </span>
                  <span class="btn-loader">
                    <span></span>
                    <span></span>
                  </span>
                </button>
                
              </div>
            `;
            break;
          default:
            this.previousElementSibling.innerHTML = `
              <div class="product-form__error-message alert alert--error text-sm font-medium leading-tight" role="alert">
                <h4 class="mt-0">We couldn’t process your ${formattedDate} order</h4>
                <p>We’re having trouble with your account. Please contact us at <a href="mailto:orders@monogramcoffee.com">orders@monogramcoffee.com</a> to resolve.</p>
                <p>Bundle Selection will be created based on you playlist and your selection.</p>
              </div>
            `;
            break;
        }
      }
    }
    this.initEvents();
  }
  renderDecafInfo(itemSubscription){
    if(this.playlistData.playlist_handle == 'mixtape'){
      const decaf_properties = itemSubscription.properties.find(property => property.name == 'decaf') || 'false';
      const currentOrderDecafInfo = this.querySelector('[data-current-order-decaf-info]');
      if(currentOrderDecafInfo && decaf_properties){
        currentOrderDecafInfo.classList.remove('hidden');
        currentOrderDecafInfo.querySelector('input').checked = decaf_properties.value == 'false';
        if(decaf_properties.value == 'false'){
          this.noDecaf = true;
        }
        else{
          this.noDecaf = false;
        }
      }
      else{
        currentOrderDecafInfo.classList.add('hidden');
      }
    }
  }
  createBundleEvent() {
    const createBundleSelectionButton = this.querySelector('[data-create-bundle-selection]');
    console.log(createBundleSelectionButton,"createBundleSelectionButton");
    if(createBundleSelectionButton){
    createBundleSelectionButton.addEventListener('click',async (e) => {
      e.preventDefault();
      try{
        createBundleSelectionButton.setAttribute('aria-busy', 'true');
        createBundleSelectionButton.classList.add('disabled');
        createBundleSelectionButton.setAttribute('disabled', 'true');
        const subscriptionId = createBundleSelectionButton.getAttribute('data-subscription-id');
        const playlistHandle = createBundleSelectionButton.getAttribute('data-playlist-handle');
        const playlist = window.playlistUtilities.getPlaylistData(playlistHandle);
        const chargeSubscription = this.rechargeDashboard.activeBundleSubscriptions.find(subscription => subscription.id == subscriptionId);
        const subscriptionProperties = chargeSubscription.properties;
        const filterCount = parseInt(subscriptionProperties.find(property => property.name == 'filter')?.value);
        const espressoCount = parseInt(subscriptionProperties.find(property => property.name == 'espresso')?.value);
        const filterBrewType = subscriptionProperties.find(property => property.name == 'grind_filter')?.value;
        const espressoBrewType = subscriptionProperties.find(property => property.name == 'grind_espresso')?.value;
        const totalCount = filterCount + espressoCount;
        const frequency = chargeSubscription.order_interval_frequency;
        let bundleObjectDf = null;
        let selectionProductListingDF = [];
        if(playlistHandle == 'mixtape'){
          try{
          const {bundleSelections,bundleObject,playlistData,totalProductPrice,selectionProductListing,discountedPrice,bundleProduct,sellingPlan,externalCollectionId} = window.playlistUtilities.getDynamicMultiPlaylistBundleSelection(playlistHandle,totalCount,{espresso:espressoCount,filter:filterCount},`${frequency} week`,this.noDecaf);
          bundleObjectDf = bundleObject;
          selectionProductListingDF = selectionProductListing;
          }
          catch(error){
            const {bundleSelections,bundleObject,playlistData,totalProductPrice,selectionProductListing,discountedPrice,bundleProduct,sellingPlan,externalCollectionId} = window.playlistUtilities.getDynamicBundleSelection(playlistHandle,totalCount,{espresso:espressoCount,filter:filterCount},`${frequency} week`,this.noDecaf);
            bundleObjectDf = bundleObject;
            selectionProductListingDF = selectionProductListing;
          }
        }
        else{
          const {bundleSelections,bundleObject,playlistData,totalProductPrice,selectionProductListing,discountedPrice,bundleProduct,sellingPlan,externalCollectionId} = window.playlistUtilities.getStaticBundleSelection(playlistHandle,totalCount,{espresso:espressoCount,filter:filterCount},`${frequency} week`);
          bundleObjectDf = bundleObject;
          selectionProductListingDF = selectionProductListing;
        }
        let grind_preference_array = [];
        let products_sku = [];
        let external_variant_id = bundleObjectDf.externalVariantId;
        let external_collection_id = playlist.collection_id;
        selectionProductListingDF.forEach(item => {
          if(item.tags.includes('espresso')){
            item.variants.forEach(variant => {
              if(variant.title == "300g" || variant.title == "300G" || variant.title == "300 G" || variant.title == "300 g"){
                grind_preference_array.push({variantId:variant.id,grind_Value:espressoBrewType});
                products_sku.push({sku:variant.sku,grindType:espressoBrewType});
              }
            });
          }
          else{
            item.variants.forEach(variant => {
              if(variant.title == "300g" || variant.title == "300G" || variant.title == "300 G" || variant.title == "300 g"){
                grind_preference_array.push({variantId:variant.id,grind_Value:filterBrewType});
                products_sku.push({sku:variant.sku,grindType:filterBrewType});
              }
            });
          }
        });
          const newProperties = window.subscriptionHelper.updateProperties(chargeSubscription.properties, {playlist_handle:playlistHandle,external_variant_id:String(external_variant_id),external_collection_id:String(external_collection_id),grind_preference_array:JSON.stringify(grind_preference_array),products_sku:JSON.stringify(products_sku)});
          console.log(bundleObjectDf,"bundleObjectDf");
          const finalBundleObject = window.playlistUtilities.convertBundleObjectToRechargeBundleObject(bundleObjectDf);
          console.log(finalBundleObject,"finalBundleObject");
          const isValid = await recharge.bundle.validateBundle(finalBundleObject);
          if(!isValid){
            window.notificationEle.updateNotification('Create Bundle Selection', 'Invalid Bundle', {
              type: 'info',
              timeout: 10000
            });
            return;
          }
          const response = await recharge.bundle.updateBundle(window.rechargeSession,chargeSubscription.id,finalBundleObject,{ order_interval_frequency: parseInt(frequency) },{ commit: true });
          console.log(response,"response");
          const response2 = await recharge.subscription.updateSubscription(window.rechargeSession,chargeSubscription.id,{properties:newProperties},{ commit: true });
          console.log(response2,"response2");
          const response3 = await recharge.address.updateAddress(window.rechargeSession,chargeSubscription.address_id,{
            order_attributes:
            [{name:'_subscriptionData',value:JSON.stringify(newProperties)}]
          });
          console.log(response3,"response3");
          document.dispatchEvent(new CustomEvent('update:subscriptionDashboard'));
          createBundleSelectionButton.removeAttribute('aria-busy');
          createBundleSelectionButton.classList.remove('disabled');
          createBundleSelectionButton.removeAttribute('disabled');
      }
      catch(error){
        console.log(error,"error");
        window.notificationEle.updateNotification('Create Bundle Selection', 'Something went wrong', {
          type: 'error',
          timeout: 10000
        });
      }
      finally{
        createBundleSelectionButton.removeAttribute('aria-busy');
        createBundleSelectionButton.classList.remove('disabled');
        createBundleSelectionButton.removeAttribute('disabled');
      }
      });
    }
  }
  renderCreateBundleSelectionHTML(chargeSubscription) {
    
    const bundleProductId = chargeSubscription.include?.bundle_product?.external_product_id;
    const nextPlaylistData = bundleProductId ? window.playlistUtilities.getPlaylistDataByBundleProductId(bundleProductId) : null;
    
    return `
      <div class="product-form__error-message alert alert--error text-sm font-medium leading-tight" role="alert">
        <h4 class="mt-0">No Bundle Selections Found</h4>
        <p>Please create a bundle selection to proceed and then you can edit,swap or schedule your next order.</p>
        <button data-create-bundle-selection data-subscription-id="${chargeSubscription.id}" data-playlist-handle="${nextPlaylistData?.playlist_handle}" class="button button--primary w-full next-order-button icon-with-text" role="link" aria-disabled="true" is="hover-button">
          <span class="btn-fill" data-fill="" style="transform: translateY(var(--motion-translateY)); --motion-translateY: -76%;"></span>
          <span class="btn-text max-w-max uppercase">
            Create Bundle Selection
          </span>
          <span class="btn-loader">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>
    `;
  }
  createNextSubscriptionOrderHTML(charge,chargeSubscription,itemSubscription,customerData,creditData,nextPlaylistData,isWithinSevenDays) {
    
    return `
      ${this.errorForNextCharge ? `
        <div class="product-form__error-message alert alert--error text-sm font-medium leading-tight" role="alert">
          <p>You have error</p>
        </div>
        `:``}    
      <p class="lg:text-lg text-base tracking-none leading-normal mb-2 lg:mb-3 mt-0">Your Next Order</p>
      <div class="flex items-center gap-2 mb-2 lg:mb-3">
        <div class="playlist-icon-image  ${nextPlaylistData?.playlist_icon == null ? 'hidden' : ''}" style="--image-width:34px;">
          <img src="${nextPlaylistData?.playlist_icon}?width=100" alt="${nextPlaylistData?.playlist_title}" class="image-fit ${nextPlaylistData?.playlist_icon == null ? 'hidden' : ''}" />
        </div>
        <span class="lg:text-2xl text-xl font-bold uppercase leading-tighter heading tracking-none">
          ${nextPlaylistData?.playlist_title}
        </span>
      </div>
      <div class="text-sm lg:text-base leading-normal flex flex-wrap items-center gap-1 mb-4">
        <span> Shipped to </span>
        <span class="font-bold"> ${charge.shipping_address.first_name} ${charge.shipping_address.last_name} , ${charge.shipping_address.address1 ? charge.shipping_address.address1 : ''} , ${charge.shipping_address.city ? charge.shipping_address.city : ''} , ${charge.shipping_address.province ? charge.shipping_address.province : ''} , ${charge.shipping_address.zip ? charge.shipping_address.zip : ''} , ${charge.shipping_address.country_code ? charge.shipping_address.country_code : ''}</span>
        <span class="account-underline-text cursor-pointer lg:ms-1 edit-address-text" aria-controls="Address-edit" aria-expanded="false"> Edit Address </span>
      </div>
      
      <div class="next-order-info mb-4 lg:mb-5">
        <div class="flex flex-col gap-1">
          <span class="text-sm lg:text-base"> Processing on </span>
          <span class="font-medium lg:text-xl text-lg tracking-none leading-tight"> ${Utility.formatDate(charge.scheduled_at)} </span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-sm lg:text-base"> Amount </span>
          ${itemSubscription.include?.bundle_selections?.items_count ? `
            <span class="font-medium lg:text-xl text-lg tracking-none leading-tight"> ${itemSubscription.include?.bundle_selections?.items_count} bags </span>
          ` : `
            <span class="font-medium lg:text-xl text-lg tracking-none leading-tight">  ${itemSubscription.include?.bundle_selections?.items.reduce((acc,item) => acc + item.quantity, 0)} bags </span>
          `}
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-sm lg:text-base"> Frequency </span>
          <span class="font-medium lg:text-xl text-lg tracking-none leading-tight"> Every ${chargeSubscription.order_interval_frequency} ${chargeSubscription.order_interval_unit}  </span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-sm lg:text-base"> Order Total </span>
          <div class="flex flex-col lg:flex-row gap-3 md:items-end">
            <span class="font-medium lg:text-xl text-lg tracking-none leading-tight"> ${theme.Currency.formatMoney(charge.total_price, theme.settings.moneyFormat)} </span>
            <span class="lg:text-sm text-2sm tracking-none leading-none account-underline-text cursor-pointer add-discount-text max-w-max" aria-controls="Apply-discount" aria-expanded="false">
              Add Discount
            </span>
          </div>
        </div>
      </div>
      <div class="rewards-box pt-2 pb-2 ps-4 pe-4 lg:pt-4 lg:pb-4 lg:ps-5 lg:pe-5 rounded-3 flex flex-col lg:flex-row gap-1 md:gap-3 justify-between mb-4 lg:mb-4">
        <div class="lg:text-base text-sm leading-normal flex flex-wrap gap-1">
          Reward Credits: <span class="font-bold tracking-none leading-normal"> ${theme.Currency.formatMoney(creditData.total_available_balance, theme.settings.moneyFormat)} </span>
        </div>
        <div class="toggle-button-parent">
          <p class="flex items-center justify-between w-full lg:w-fit gap-5 mt-0 mb-0 lg:text-sm text-2sm">
            Auto-apply to your next order <span data-apply-credit-next-order class="toggle-button ${customerData.apply_credit_to_next_recurring_charge ? 'checked' : ''}"> </span>
          </p>
        </div>
      </div>
      <div class="pt-2 pb-2 ps-4 pe-4 lg:pt-4 lg:pb-4 lg:ps-5 lg:pe-5 rounded-3 flex flex-row gap-1 md:gap-3 justify-between mb-4 lg:mb-4 hidden upcoming-order-decaf-info" data-current-order-decaf-info>
        <div class="block">
          <p class="lg:text-base text-sm leading-normal font-bold mb-0 mt-0 relative z-1">No Decaf:
            <span class="decaf-tooltip-button" tabindex="0">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              <span class="decaf-tooltip-text text-xs" role="tooltip">${ window.globalMessages.no_decaf_info}</span>
            </span>
          </p>
          <p class="mt-0 mb-0 flex items-center justify-between w-full lg:w-fit gap-5 lg:text-sm text-2sm">Turn this on to exclude decaf coffees from your subscription.</p>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" class="upcoming-order-decaf-toggle" id="decafToggle-${charge.id}"">
          <span class="slider"></span>
        </label>
      </div>
      <div class="next-order-buttons relative flex flex-col sm:flex-row gap-2 mb-5">
        <div class="flex flex-col sm:flex-row gap-3">
            <button class="button button--secondary gap-3 w-full lg:w-auto lg:max-w-max icon-with-text button--sm" role="link" aria-disabled="true" is="hover-button" aria-controls="Skip-order" aria-expanded="false">
              <span class="btn-fill" data-fill=""></span>
              <span class="btn-text max-w-max uppercase">
                  <svg class="icon icon-skip icon-sm transform" viewBox="0 0 18 14" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.42188 1V13.1333L10.685 7.06667L1.42188 1Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M7.31641 9.27667V13.1333L16.5796 7.06667L7.31641 1V4.85667" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  Skip
              </span>
              <span class="btn-loader">
              <span></span>
              <span></span>
              <span></span>
              </span>
            </button>
            <button class="button button--secondary gap-3 w-full lg:w-auto lg:max-w-max icon-with-text button--sm" role="link" aria-disabled="true" is="hover-button" date-disabled-date="${charge.scheduled_at}" aria-controls="schedule-next-order" aria-expanded="false">
              <span class="btn-fill" data-fill=""></span>
              <span class="btn-text max-w-max uppercase">
                  <svg class="icon icon-schedule icon-sm transform" viewBox="0 0 18 14" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.42188 1V13.1333L10.685 7.06667L1.42188 1Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M7.31641 9.27667V13.1333L16.5796 7.06667L7.31641 1V4.85667" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  Schedule
              </span>
              <span class="btn-loader">
              <span></span>
              <span></span>
              <span></span>
              </span>
            </button><button class="button button--secondary gap-3 w-full lg:w-auto lg:max-w-max current-order-desktop-button icon-with-text button--sm" role="link" aria-disabled="true" is="hover-button" aria-controls="swap-playlist-trigger" aria-expanded="false">
              <span class="btn-fill" data-fill="" style="transform: translateY(var(--motion-translateY)); --motion-translateY: -76%;"></span>
              <span class="btn-text max-w-max uppercase">
                  <svg class="icon icon-swap-playlist icon-sm transform" viewBox="0 0 18 18" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.5295 4.22357H3.35306C2.31776 4.22357 1.4707 5.07063 1.4707 6.10592V8.92945" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M13.7051 1.40002L16.5286 4.22355L13.7051 7.04708" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M1.4707 13.6353H14.6472C15.6825 13.6353 16.5295 12.7883 16.5295 11.753V8.92944" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M4.29423 16.4588L1.4707 13.6353L4.29423 10.8118" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  Swap Subscription
              </span>
              <span class="btn-loader">
              <span></span>
              <span></span>
              <span></span>
              </span>
            </button>
            ${nextPlaylistData?.is_curated_playlist? ` `: 
            `<button class="button button--secondary gap-3 w-full lg:w-auto lg:max-w-max icon-with-text button--sm" role="link" aria-disabled="true" is="hover-button" aria-controls="Subscription-edit-modal" aria-expanded="false">
              <span class="btn-fill" data-fill=""></span>
              <span class="btn-text max-w-max uppercase">
                  <svg class="icon icon-edit-playlist icon-sm transform" viewBox="0 0 17 17" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.4707 15.5294L2.44011 11.6518L13.1436 0.948242L16.0519 3.85648L5.34835 14.56L1.4707 15.5294Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M10.5 4L13 6.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  Edit
              </span>
              <span class="btn-loader">
              <span></span>
              <span></span>
              <span></span>
              </span>
            </button>`}
        </div>
      
        <button aria-controls="swap-playlist-trigger" class="button button--secondary w-full gap-3 current-order-mobile-button icon-with-text button--sm" role="link" aria-disabled="true" is="hover-button">
            <span class="btn-fill" data-fill=""></span>
            <span class="btn-text max-w-max uppercase">
              <svg class="icon icon-swap-playlist icon-sm transform" viewBox="0 0 18 18" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.5295 4.22357H3.35306C2.31776 4.22357 1.4707 5.07063 1.4707 6.10592V8.92945" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M13.7051 1.40002L16.5286 4.22355L13.7051 7.04708" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M1.4707 13.6353H14.6472C15.6825 13.6353 16.5295 12.7883 16.5295 11.753V8.92944" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M4.29423 16.4588L1.4707 13.6353L4.29423 10.8118" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              Swap Subscription
            </span>
        </button>
      </div>
      <div class="next-order-products mb-4 lg:mb-5 relative ${isWithinSevenDays ? '' : 'next-order-overlay-enabled'}">
        ${isWithinSevenDays ? '' : `
        <div class="next-order-overlay">
          <h4 class="text-lg tracking-none leading-normal font-bold heading mt-0 mb-0">coffees will be revealed 7 days before your next order processes</h4>
        </div>`}
        ${charge.line_items.map((item)=>{
          return this.createNextOrderProductHTML(item,chargeSubscription,nextPlaylistData);
        }).join('')}
      </div>
      ${charge.line_items.some(item => item.purchase_item_type == 'onetime') ? `
        <div class="lg:text-lg text-base uppercase font-bold heading tracking-none leading-normal mb-4 mt-0 lg:pt-2">One-Time Add Ons</div>
        <div class="next-order-products mb-4 lg:mb-5">
          ${charge.line_items.filter(item => item.purchase_item_type == 'onetime').map((item)=>{
            return this.craeteOnetimeProductHTML(item,chargeSubscription);
          }).join('')}
        </div>
        ` : ''}
      <button data-add-on-button class="button button--primary w-full next-order-button icon-with-text" role="link" aria-disabled="true" is="hover-button">
        <span class="btn-fill" data-fill="" style="transform: translateY(var(--motion-translateY)); --motion-translateY: -76%;"></span>
        <span class="btn-text uppercase">
          Add One-Time products
        <svg class="icon icon-arrow-right icon-sm transform" viewBox="0 0 21 20" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 10H18M18 10L12.1667 4.16675M18 10L12.1667 15.8334"></path>
        </svg>
        </span>
        <span class="btn-loader">
        <span></span>
        <span></span>
        <span></span>
        </span>
      </button>
    `;
  }
  createNextOrderProductHTML(item,chargeSubscription,nextPlaylistData) {
    if(item.purchase_item_type == 'onetime'){
      return '';
     }
     
     const isBundleProduct = window.all_bundle_products.find(product => {
      return product.id == item.external_product_id.ecommerce;
     });
     if(isBundleProduct){
      return '';
     }

    const productObject = window.playlistUtilities.getProductObjectById(item.external_product_id.ecommerce);
    if(item.offer_attributes?.type === 'free_gift' && productObject == null){
      const product = window.getProductById(item.external_product_id.ecommerce);
      return `<product-line-item class="pt-2 pb-2 ps-2 pe-2 lg:pt-4 lg:pb-4 lg:ps-4 lg:pe-4 rounded-3 product-line-item" data-playlist-handle="${nextPlaylistData?.playlist_handle}" data-external-collection-id="${nextPlaylistData.collection_id}" data-variant-id="${item.external_variant_id.ecommerce}" data-product-id="${item.external_product_id.ecommerce}" data-subscription-id="${chargeSubscription.id}">
      <div class="flex items-center gap-4 mb-2 lg:mb-3">
        <img src="${product.featured_image}?width=100" alt="${item.title}" height="100" width="100" class="mt-0 mb-0">
        <div>
          <div class="lg:text-base text-sm font-bold leading-tight mb-2 uppercase tracking-none heading">
            ${item.title} ${item.quantity > 1 ? `x ${item.quantity}` : ''}
          </div>
          <div class="account-tag tag-secondary">Free Gift</div>
        </div>
      </div>
    </product-line-item>`;
    }
   
   if(productObject == null){
    return `<product-line-item class="pt-2 pb-2 ps-2 pe-2 lg:pt-4 lg:pb-4 lg:ps-4 lg:pe-4 rounded-3 product-line-item" data-playlist-handle="${nextPlaylistData.playlist_handle}" data-external-collection-id="${nextPlaylistData.collection_id}" data-variant-id="${item.external_variant_id.ecommerce}" data-product-id="${item.external_product_id.ecommerce}" data-subscription-id="${chargeSubscription.id}">
      <div class="flex items-center gap-4 mb-2 lg:mb-3">
        <img src="${item.images.small}" alt="${item.title}" height="100" width="100" class="mt-0 mb-0">
        <div>
          <div class="lg:text-base text-sm font-bold leading-tight mb-2 uppercase tracking-none heading">
            ${item.title} ${item.quantity > 1 ? `x ${item.quantity}` : ''}
          </div>
        </div>
      </div>
       <div class="flex lg:items-center gap-3d5 sold-out-info rounded-2 pt-2 pb-2 ps-2 pe-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_2518_4551)">
                <path d="M7.99978 15.1111C11.9271 15.1111 15.1109 11.9274 15.1109 8.00003C15.1109 4.07267 11.9271 0.888916 7.99978 0.888916C4.07242 0.888916 0.888672 4.07267 0.888672 8.00003C0.888672 11.9274 4.07242 15.1111 7.99978 15.1111Z" stroke="#6C6D6D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M8.00022 5.77778C8.49114 5.77778 8.88911 5.37981 8.88911 4.88889C8.88911 4.39797 8.49114 4 8.00022 4C7.5093 4 7.11133 4.39797 7.11133 4.88889C7.11133 5.37981 7.5093 5.77778 8.00022 5.77778Z" fill="#6C6D6D"></path>
                <path d="M8 7.55554V11.1111" stroke="#6C6D6D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
            </g>
            <defs>
                <clipPath id="clip0_2518_4551">
                  <rect width="16" height="16" fill="white"></rect>
                </clipPath>
            </defs>
          </svg>
          <div class="mt-0 mb-0 text-xs">
            <span> This Product is Not Available Please swap with another Product </span>
            <span class="account-underline-text cursor-pointer font-bold block max-w-max" data-swap-product data-swap-coffee data-quantity="${item.quantity}" data-product-id="${item.external_product_id.ecommerce}" data-variant-id="${item.external_variant_id.ecommerce}" data-product-title="${item.title}">
              Swap For Another Product
            </span>
          </div>
      </div>
    </product-line-item>`;
   }
  

   let grindPreferenceArrayFound = false;
   let grindPreferenceArray = [];
   if(chargeSubscription.properties.find(property => property.name == 'grind_preference_array')){
    grindPreferenceArrayFound = true;
    grindPreferenceArray = JSON.parse(chargeSubscription.properties.find(property => property.name == 'grind_preference_array')?.value);
   }


   const selectedVariant = productObject.variants.find(variant => variant.id == parseInt(item.external_variant_id.ecommerce));
   let grindType = "";
   let coffeeBrew = "";
   if (productObject.tags.includes('espresso')){
     coffeeBrew = 'espresso';
    grindType = chargeSubscription.properties.find(property => property.name == 'grind_espresso') ? chargeSubscription.properties.find(property => property.name == 'grind_espresso')?.value : "";

    if(grindPreferenceArrayFound){
      if(grindPreferenceArray.find(item => item.variantId == selectedVariant.id)){
        grindType = grindPreferenceArray.find(item => item.variantId == selectedVariant.id)?.grind_Value;
      }
      else{
        grindType = chargeSubscription.properties.find(property => property.name == 'grind_espresso') ? chargeSubscription.properties.find(property => property.name == 'grind_espresso')?.value : "";
      }
    }
   }else if (productObject.tags.includes('filter')){
    coffeeBrew = 'filter';
    grindType = chargeSubscription.properties.find(property => property.name == 'grind_filter') ? chargeSubscription.properties.find(property => property.name == 'grind_filter')?.value : "";

    if(grindPreferenceArrayFound){
      if(grindPreferenceArray.find(item => item.variantId == selectedVariant.id)){
        grindType = grindPreferenceArray.find(item => item.variantId == selectedVariant.id)?.grind_Value;
      }
      else{
        grindType = chargeSubscription.properties.find(property => property.name == 'grind_filter') ? chargeSubscription.properties.find(property => property.name == 'grind_filter')?.value : "";
      }
    }
   }
  
   chargeSubscription.properties.find(property => property.name == 'grind_preference_array') ? chargeSubscription.properties.find(property => property.name == 'grind_preference_array')?.value : "";


    return `
      <product-line-item class="pt-2 pb-2 ps-2 pe-2 lg:pt-4 lg:pb-4 lg:ps-4 lg:pe-4 rounded-3 product-line-item" data-playlist-handle="${nextPlaylistData.playlist_handle}" data-variant-id="${selectedVariant.id}" data-external-collection-id="${nextPlaylistData.collection_id}" data-product-id="${productObject.id}" data-subscription-id="${chargeSubscription.id}" data-coffee-brew="${coffeeBrew}" data-grind-type="${grindType}">
            <div class="flex items-center gap-4 mb-2 lg:mb-3">
              <img src="${productObject.featured_image}?width=200" alt="${productObject.title}" height="100" width="100" class="mt-0 mb-0">
              <div>
                  <div class="lg:text-base text-sm font-bold leading-tight mb-2 uppercase tracking-none heading">
                    ${productObject.title} ${item.quantity > 1 ? `x ${item.quantity}` : ''}
                  </div>
                  <div class="text-xs flex gap-3 leading-normal items-center lg:mb-5">
                    ${selectedVariant.title}
                     ${grindType  != "whole-beans" && grindType != "" ? `<span class="account-tag tag-primary"> ${Utility.stringHelper.formateGrindType(grindType)} </span>` : ''}
                      ${grindType  == "whole-beans" && grindType != "" ? `<span class="account-tag tag-primary"> ${Utility.stringHelper.formateGrindType(grindType)} </span>` : ''}
                  </div>
                  <div class="hidden lg:flex flex-wrap gap-4">
                    <span class="account-underline-text cursor-pointer text-sm font-medium" data-edit-grind-type data-product-id="${productObject.id}" data-variant-id="${selectedVariant.id}" data-coffee-brew="${coffeeBrew}"> Edit Grind Type </span>
                    <span class="account-underline-text cursor-pointer text-sm font-medium" data-swap-coffee data-quantity="${item.quantity}" data-product-id="${productObject.id}" data-variant-id="${selectedVariant.id}" data-product-title="${productObject.title}"> Swap Coffee </span>
                  </div>
              </div>
            </div>
            <div class="lg:hidden flex flex-wrap gap-2 mb-4 lg:mb-0">
              <span class="button button--sm button--secondary cursor-pointer text-sm" data-edit-grind-type data-product-id="${productObject.id}" data-variant-id="${selectedVariant.id}" data-coffee-brew="${coffeeBrew}">
              Edit Grind Type
              </span>
              <span class="button button--sm button--secondary cursor-pointer text-sm" data-swap-coffee data-quantity="${item.quantity}" data-product-id="${productObject.id}" data-variant-id="${selectedVariant.id}" data-product-title="${productObject.title}">
              Swap Coffee
              </span>
            </div>
            <div class="mb-2 lg:mb-3">
              <p class="mt-0 mb-0 lg:text-sm text-2sm">
                  ${productObject.description != "" ? productObject.description.length > 100 ? productObject.description.substring(0, 100) + '...' : productObject.description : " "}
              </p>
              ${selectedVariant.available == false ? `
              <div class="flex lg:items-center gap-3d5 sold-out-info rounded-2 pt-2 pb-2 ps-2 pe-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_2518_4551)">
                        <path d="M7.99978 15.1111C11.9271 15.1111 15.1109 11.9274 15.1109 8.00003C15.1109 4.07267 11.9271 0.888916 7.99978 0.888916C4.07242 0.888916 0.888672 4.07267 0.888672 8.00003C0.888672 11.9274 4.07242 15.1111 7.99978 15.1111Z" stroke="#6C6D6D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M8.00022 5.77778C8.49114 5.77778 8.88911 5.37981 8.88911 4.88889C8.88911 4.39797 8.49114 4 8.00022 4C7.5093 4 7.11133 4.39797 7.11133 4.88889C7.11133 5.37981 7.5093 5.77778 8.00022 5.77778Z" fill="#6C6D6D"></path>
                        <path d="M8 7.55554V11.1111" stroke="#6C6D6D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </g>
                    <defs>
                        <clipPath id="clip0_2518_4551">
                          <rect width="16" height="16" fill="white"></rect>
                        </clipPath>
                    </defs>
                  </svg>
                  <div class="mt-0 mb-0 text-xs">
                    <span> Your last pick sold out. We swapped in this one from the same playlist. </span>
                    <span class="account-underline-text cursor-pointer font-bold block max-w-max">
                    Swap For Another Coffee
                    </span>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M1 13L13 1M1 1L13 13" stroke="#6C6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
              </div>
              ` : ''}
            </div>
            ${productObject.origin != "" ? `
            <div class="leading-normal gap-3 mb-2 pb-2 next-order-info-box flex justify-between">
              <span class="lg:text-sm text-2sm font-bold tracking-none min-w-max"> Origin </span>
              <span class="lg:text-sm text-2sm"> ${productObject.origin} </span>
            </div>
            `:''}
            ${productObject.variety != "" ? `
            <div class="leading-normal gap-3 mb-2 pb-2 next-order-info-box flex justify-between">
              <span class="lg:text-sm text-2sm font-bold tracking-none min-w-max"> Varietal </span>
              <span class="lg:text-sm text-2sm"> ${productObject.variety} </span>
            </div>
            ` : ''}
            ${productObject.processing_method != "" ? `
            <div class="leading-normal gap-3 mb-2 pb-2 next-order-info-box flex justify-between">
              <span class="lg:text-sm text-2sm font-bold tracking-none min-w-max"> Processing Method </span>
              <span class="lg:text-sm text-2sm"> ${productObject.processing_method} </span>
            </div>
            ` : ''}
            ${productObject.testing_notes.length > 0 ? `
            <div class="leading-normal gap-3 next-order-info-box flex justify-between">
              <span class="lg:text-sm text-2sm font-bold tracking-none min-w-max"> Tasting Notes </span>
              <span class="lg:text-sm text-2sm"> ${productObject.testing_notes.join(', ')} </span>
            </div>
            ` : ''}
        </product-line-item>
    `;
  }
  craeteOnetimeProductHTML(item,chargeSubscription) {
    console.log(item,"item");
    const productObject = window.getProductById(item.external_product_id.ecommerce);
   if(productObject == null){
    return '';
   }
   const selectedVariant = productObject.variants.find(variant => variant.id == parseInt(item.external_variant_id.ecommerce));
   let grindType = "";
   let coffeeBrew = "";
   if (productObject.tags.includes('espresso')){
     coffeeBrew = 'espresso';
      grindType = item.properties.find(property => property.name == 'grind_espresso') ? item.properties.find(property => property.name == 'grind_espresso').value : "";
   }else if (productObject.tags.includes('filter')){
    coffeeBrew = 'filter';
    grindType = item.properties.find(property => property.name == 'grind_filter') ? item.properties.find(property => property.name == 'grind_filter').value : "";
   }
    return `
          <one-time-product-item class="pt-2 pb-2 ps-2 pe-2 lg:pt-4 lg:pb-4 lg:ps-4 lg:pe-4 rounded-3 product-line-item relative" data-purchase-item-id="${item.purchase_item_id}" data-product-id="${productObject.id}" data-subscription-id="${chargeSubscription.id}" data-coffee-brew="${coffeeBrew}" data-grind-type="${grindType}">
            <div class="flex items-center gap-4 mb-2 lg:mb-0">
              <img src="${productObject.featured_image}?width=200" alt="${item.title}" height="100" width="100" class="mt-0 mb-0" data-product-image>
              <div class="w-full">
                <div class="flex items-start w-full justify-between gap-4">
                  <div>
                    <div class="lg:text-base text-sm font-bold leading-tight mb-2 uppercase tracking-none heading">
                      ${item.title}
                    </div>
                    <div class="text-xs flex gap-3 leading-normal items-center lg:mb-5">
                      ${grindType  != "whole-beans" && grindType != "" ? `<span class="account-tag tag-secondary"> ${Utility.stringHelper.formateGrindType(grindType)} </span>` : ''}
                      ${grindType  == "whole-beans" && grindType != "" ? `<span class="account-tag tag-primary"> ${Utility.stringHelper.formateGrindType(grindType)} </span>` : ''}
                    </div>
                  </div>
                  <button class="p-2 one-time-remove-button hidden lg:block relative" data-remove-onetime-product data-product-id="${productObject.id}" data-purchase-item-id="${item.purchase_item_id}"> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M4 16L16 4M4 4L16 16" stroke="#6C6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
                  <span class="text-sm font-bold tracking-none mt-2 lg:mt-0 block lg:hidden"> ${item.quantity} x ${theme.Currency.formatMoney(item.unit_price, theme.settings.moneyFormat)} </span>
                  <div class="hidden lg:flex flex-wrap justify-between gap-4">
                    <span data-edit-onetime-product data-product-id="${productObject.id}" class="account-underline-text cursor-pointer text-sm" data-edit-grind-type> Edit </span>
                    <span class="text-sm font-bold tracking-none"> ${item.quantity} x ${theme.Currency.formatMoney(item.unit_price, theme.settings.moneyFormat)} </span>
                  </div>
              </div>
            </div>
            <div class="lg:hidden flex gap-2d5">
              <button class="button button--sm button--secondary cursor-pointer text-sm w-full" is="hover-button" data-mobile-edit-onetime-product data-purchase-item-id="${item.purchase_item_id}" data-edit-onetime-product data-product-id="${productObject.id}">
              Edit
              </button>
              <button class="button button--sm button--secondary cursor-pointer text-sm w-full" data-mobile-remove-onetime-product is="hover-button" data-product-id="${productObject.id}" data-purchase-item-id="${item.purchase_item_id}">
                <span class="btn-fill" data-fill></span>
                <span class="btn-text">
                Remove
                </span>
                <span class="btn-loader">
                <span></span>
                <span></span>
                </span>
              </button>
            </div>
        </one-time-product-item>
    `;
  }
}
customElements.define('next-subscription-order', NextSubscriptionOrder);
class CurrentOrderBlock extends HTMLElement {
  constructor() {
    super();
    this.currentOrderListWrapper = this.querySelector('[data-current-order-list-wrapper]');
    this.rechargeDashboard = document.querySelector('recharge-dashboard');
    this.dataParentId = this.getAttribute('data-bundle-parent-id');
    this.currentOrderDecafInfo = this.querySelector('[data-current-order-decaf-info]') || null;
    this.isRepeatCoffeeUpdating = false;
  }
  connectedCallback() {
    this.subscriptionProperties = JSON.parse(this.getAttribute('data-subscription-properties'));
    this.initHeartEvents();
    this.initRepeatedCoffeeEvents();
    this.initRepeatCoffeeTooltip();
  }
  initRepeatCoffeeTooltip(){
    const btn = this.querySelector('.info-for-repeat-coffee-tooltip-button');
    if (!btn) return;

    btn.addEventListener('touchstart', (e) => {
      e.preventDefault();
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }, { passive: false });

    document.addEventListener('touchstart', (e) => {
      if (!btn.contains(e.target)) {
        btn.setAttribute('aria-expanded', 'false');
      }
    }, { passive: true });
  }

   initRepeatedCoffeeEvents(){
    this.querySelectorAll('[data-item-repeat-coffee-toggle]').forEach(item => {
      item.querySelector('input').addEventListener('change', async (e) => {
        const toggle = e.target;
        const wrapper = item.closest('.item-toggle-repeat-coffee-wrapper');

        if (this.isRepeatCoffeeUpdating) {
          toggle.checked = !toggle.checked;
          return;
        }

        const previousChecked = !toggle.checked;
        const variantId = toggle.getAttribute('data-variant-id');
        const productId = toggle.getAttribute('data-product-id');
        const collectionId = toggle.getAttribute('data-collection-id');

        this.isRepeatCoffeeUpdating = true;
        toggle.disabled = true;
        wrapper?.setAttribute('aria-busy', 'true');

        try {
          await this.requestUpdateRepeatedCoffeeData(collectionId, productId, variantId, toggle.checked);
          // await window.changeSubscriptionPlaylistProductOrder();
          // await this.updateNextSubscriptionPlaylist();
          // document.dispatchEvent(new CustomEvent('update:subscriptionDashboard'));
        } catch (error) {
          console.log(error,"error");
          console.error(error);
          toggle.checked = previousChecked;
          window.notificationEle?.updateNotification('Repeat Coffee', 'Something went wrong updating your preference', {
            type: 'error',
            timeout: 10000
          });
        } finally {
          this.isRepeatCoffeeUpdating = false;
          toggle.disabled = false;
          wrapper?.removeAttribute('aria-busy');
        }
      });
    });
  }
  async updateNextSubscriptionPlaylist(){
    const nextOrder = document.querySelector('next-subscription-order');
    if(nextOrder){
      const subscription = nextOrder.subscription
      
      const decaf = nextOrder.noDecaf || false;
      await nextOrder.swapeSubscriptionFromProperties(subscription,decaf);
      
    }
  }
  async requestUpdateRepeatedCoffeeData(collectionId, productId, variantId, isEnabled){
    try{
    const response = await fetch("/apps/proxy/repeat-coffee/customer", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customerId: window.customer.id,
        collectionId: collectionId,
        productId: productId,
        variantId: variantId,
        isEnabled: isEnabled
      })
    });
    console.log(response,"response");

    const jsonResponse = await response.json();
    console.log(jsonResponse,"jsonResponse");
    if (!jsonResponse.success) {
      throw new Error(jsonResponse.message || 'Failed to update repeat coffee preference');
    }
    return {success: true, message: 'Repeat coffee preference updated successfully'};
  }
  catch(error){
    console.error(error);
    return {success: false, message: error.message};
    }
  }
  async renderProperties(){
    let playlistHandle = '';
    if(this.dataParentId != ''){
      const playlistD = window.playlistUtilities.getPlaylistDataByBundleProductId(this.dataParentId);
      playlistHandle = playlistD.playlist_handle;
    }
    else{
       playlistHandle = this.subscriptionProperties.find(property => property.name == 'playlist_handle')?.value;
    }
    
    if(playlistHandle){
      this.playlistData = window.playlistUtilities.getPlaylistData(playlistHandle);
      this.rechargeDashboard.currentlyEnjoyingPlaylistData = this.playlistData;
      if(!this.playlistData){return;}
      this.bundleMainProductId = this.playlistData.bundle_product.id;
      this.collectionId = this.playlistData.collection_id;
      if(this.bundleMainProductId){
        if(this.querySelector(`[data-product-id="${this.bundleMainProductId}"]`)){
          this.querySelector(`[data-product-id="${this.bundleMainProductId}"]`)?.classList.add('hidden');
        }
      }
      this.setAttribute('data-playlist-name',playlistHandle);
      document.querySelectorAll('[data-playlist-title]')?.forEach(item => {
        item.innerHTML = this.playlistData.playlist_title;
      });
      document.querySelectorAll('[data-current-playlist-target]')?.forEach(item => {
        item.setAttribute('data-playlist-name',playlistHandle);
      })
      this.querySelectorAll('[data-playlist-icon]')?.forEach(item => {
        if(this.playlistData.playlist_icon){
          item.src = this.playlistData.playlist_icon;
        }
        else{
          item.classList.add('hidden');
          item.parentElement.classList.add('hidden');
        }
      });
      const currentPlaylistTarget = document.querySelector('[data-current-playlist-target]');
      if(currentPlaylistTarget){
        currentPlaylistTarget.querySelectorAll('[data-playlist-icon]')?.forEach(item => {
          if(this.playlistData.playlist_icon){
            item.src = this.playlistData.playlist_icon;
          }
          else{
            item.classList.add('hidden');
            item.parentElement.classList.add('hidden');
          }
        });
        currentPlaylistTarget.querySelectorAll('[data-current-playlist-tasting-notes]')?.forEach(item => {
          item.textContent = this.playlistData.playlist_description;
        });
      }
      
      document.querySelectorAll('[data-current-enjoying-svg]')?.forEach(item => {
        if(this.playlistData.playlist_svg_icon_1){
          item.innerHTML = `<img src="${this.playlistData.playlist_svg_icon_1}" alt="${this.playlistData.playlist_title}" />`;
        }
        else{ 
          item.classList.add('hidden');
        }
      });
      if(document.querySelector('[data-current-enjoying-svg]')){
        if(this.playlistData.playlist_svg_icon_1){
          this.querySelector('[data-current-enjoying-svg]').innerHTML = `<img src="${this.playlistData.playlist_svg_icon_1}" alt="${this.playlistData.playlist_title}" />`;
        }
        else{
          this.querySelector('[data-current-enjoying-svg]').classList.add('hidden');
        }
      }
      this.querySelectorAll('.coffee-order-card')?.forEach(item => {
        item.querySelectorAll('[data-heart-button]')?.forEach(item => {
          item.setAttribute('data-collection-id',this.collectionId);
        });
      });
      this.querySelectorAll('[data-item-repeat-coffee-toggle]')?.forEach(item => {
        item.querySelector('input').setAttribute('data-collection-id',this.collectionId);
      });
       await this.fetchRepeatedCoffeeData();
       await this.updateHTMLWithRepeatedCoffeeData();
       await this.renderDecafInfo();
    }
  }
  async renderDecafInfo(){
    if(this.playlistData.playlist_handle == 'mixtape'){
      const decaf_properties = this.subscriptionProperties.find(property => property.name == 'decaf') || 'false';
      if(decaf_properties){
        this.currentOrderDecafInfo.classList.remove('hidden');
        this.currentOrderDecafInfo.querySelector('input').checked = decaf_properties.value == 'false';
        console.log(this,"this.noDecaf");
        if(decaf_properties.value == 'false'){
          this.noDecaf = true;
        }
        else{
          this.noDecaf = false;
        }
      }
      else{
        this.currentOrderDecafInfo.classList.add('hidden');
      }
    }
  }
  async updateHTMLWithRepeatedCoffeeData(){
    const preferences = this.repeatedCoffeeData || [];

    this.querySelectorAll('.repeat-coffee-toggle-input').forEach(input => {
      const productId = input.getAttribute('data-product-id');
      const isEnabled = preferences.some(preference => String(preference.productId) === String(productId));
      input.checked = isEnabled;
    });
  }
  async fetchRepeatedCoffeeData(){
    const response = await fetch(`/apps/proxy/repeat-coffee/customer/${window.customer.id}`);
    const data = await response.json();
    this.repeatedCoffeeData = data?.slotPreferences || [];
    window.repeatedCoffeedata = data?.slotPreferences || [];
    window.changeSubscriptionPlaylistProductOrder();
  }
  async rednerCurrentOrderBlock(){
    if(this.subscriptionProperties){
      this.renderProperties();
      await this.renderBrewType();
      this.removeAttribute('is-loading');
    }
    if(this.heartedProducts){
      if(this.heartedProducts.length > 0){
        this.querySelectorAll('.coffee-order-card').forEach(item => {
          const variantId = item.getAttribute('data-variant-id');
          const isHearted = this.heartedProducts.some(
            heart => heart.variantId == variantId
          );
          if (isHearted) {
            const heartBtns = item.querySelectorAll('[data-heart-button]'); 
            if (heartBtns) {
              heartBtns.forEach(heartBtn => {
                heartBtn.classList.add('order-heart-button'); // ✅ add a meaningful class
              });
            }
          }
        });
      }
    }
  }
  async renderBrewType(){
    this.querySelectorAll('.coffee-order-card').forEach(item => {
      const brewType = item.querySelector('.breq-select-type').getAttribute('data-brew-type');
      let brewValue = "";
      let grindPreferenceArrayFound = false;
      this.subscriptionProperties.forEach(property => {
        if(property.name == 'grind_preference_array'){
          grindPreferenceArrayFound = true;
        }
      });
      if(grindPreferenceArrayFound){
        const grindPreferenceArray = JSON.parse(this.subscriptionProperties.find(property => property.name == 'grind_preference_array')?.value);
        const variantId = parseInt(item.getAttribute('data-variant-id'));
        const grindPreference = grindPreferenceArray.filter(item => item.variantId == variantId);
        if(grindPreference.length > 0){
          brewValue = grindPreference[0].grind_Value;
          item.querySelector('.breq-select-type').innerHTML = brewValue;
          item.querySelector('.breq-select-type').classList.remove('hidden');
          if(brewValue == "whole-beans" || brewValue == "whole-bean"){
            item.querySelector('.breq-select-type').innerHTML =  Utility.stringHelper.formateGrindType(brewValue);
            // item.querySelector('.breq-select-type').classList.remove('tag-secondary');
            // item.querySelector('.breq-select-type').classList.add('tag-primary');
          }
        }
      }
      else{
        if(brewType){
          if(brewType == 'espresso'){
            if(typeof this.subscriptionProperties.grind_espresso == 'undefined'){
              brewValue = this.subscriptionProperties.find(property => property.name == 'grind_espresso')?.value;
              item.querySelector('.breq-select-type').innerHTML = brewValue;
              item.querySelector('.breq-select-type').classList.remove('hidden');
              if(brewValue == "whole-beans"){
                item.querySelector('.breq-select-type').innerHTML =  Utility.stringHelper.formateGrindType(brewValue);
                // item.querySelector('.breq-select-type').classList.add('tag-primary');
                // item.querySelector('.breq-select-type').classList.remove('tag-primary');
              }
            }
          }
          else if(brewType == 'filter'){
            if(typeof this.subscriptionProperties.grind_filter == 'undefined'){
              brewValue = this.subscriptionProperties.find(property => property.name == 'grind_filter')?.value;
              item.querySelector('.breq-select-type').innerHTML = Utility.stringHelper.formateGrindType(brewValue);
              item.querySelector('.breq-select-type').classList.remove('hidden');
              if(brewValue == "whole-beans"){
                // item.querySelector('.breq-select-type').classList.add('tag-secondary');
                // item.querySelector('.breq-select-type').classList.remove('tag-primary');
              }
            }
          }
        }
      }
    });
  }
  async setupCurrentOderBlock(){
    const rechargeDashboard = document.querySelector('recharge-dashboard');
    if(rechargeDashboard){
      this.heartedProducts = rechargeDashboard.heartedProducts;
    }
    await this.rednerCurrentOrderBlock();
  }

  async fetchHeartedProducts() {
    try {
      const response = await fetch(`/apps/proxy/coffee/heart/${window.customer.id}`)
      const data = await response.json();
      this.heartedProducts = data.coffee;
    }
    catch (error) {
      console.error("🚨 Error sending request:", error.message);
      this.heartedProducts = [];
    }
  }
  initHeartEvents(){
    this.querySelectorAll('[data-heart-button]').forEach(button => {
      button.addEventListener('click', function(e){
        const variantId = this.getAttribute('data-item-variant-id');
        const productId = this.getAttribute('data-item-id');
        const collectionId = this.getAttribute('data-collection-id');
        const orderId = this.getAttribute('data-order-id');
        if(this.classList.contains('order-heart-button')){
          this.setAttribute('aria-disabled', 'true');
          this.setAttribute('aria-busy', 'true');
          fetch('/apps/proxy/coffee/heart', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              variantId: variantId,
              productId: productId,
              collectionId: collectionId,
              customerId: window.customer.id,
              orderId: orderId,
              isHearted: false
            }),
          })
          .then(async (response) => {
            if (!response.ok) {
              const errorText = await response.text();
              throw new Error(`❌ Request failed with ${response.status}: ${errorText}`);
            }
            return response.json();
          })
          .then((data) => {
            console.log("✅ Test Successful! Response:", data);
            this.classList.toggle('order-heart-button');
          })
          .catch((error) => {
            console.error("🚨 Error sending request:", error.message);
            window.notificationEle.updateNotification('Heart Product', error.message, {
              type: 'error',
              timeout: 10000
            });
          })
          .finally(() => {
            this.setAttribute('aria-disabled', 'false');
            this.setAttribute('aria-busy', 'false');
          });
        }
        else{
          this.setAttribute('aria-disabled', 'true');
          this.setAttribute('aria-busy', 'true');
          fetch('/apps/proxy/coffee/heart', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              variantId: variantId,
              productId: productId,
              collectionId: collectionId,
              customerId: window.customer.id,
              orderId: orderId,
              isHearted: true
            }),
          })
          .then(async (response) => {
            if (!response.ok) {
              const errorText = await response.text();
              throw new Error(`❌ Request failed with ${response.status}: ${errorText}`);
            }
            return response.json();
          })
          .then((data) => {
            console.log("✅ Test Successful! Response:", data);
            this.classList.toggle('order-heart-button');
          })
          .catch((error) => {
            console.error("🚨 Error sending request:", error.message);
            window.notificationEle.updateNotification('Heart Product', error.message, {
              type: 'error',
              timeout: 10000
            });
          })
          .finally(() => {
            this.setAttribute('aria-disabled', 'false');
            this.setAttribute('aria-busy', 'false');
          });
        }
        
        
      });
    });
  }
}

customElements.define('current-order-block', CurrentOrderBlock);

document.addEventListener('DOMContentLoaded', () => {
  const referCopyButton = document.querySelector('[data-refer-copy-button]');
  if(referCopyButton){
  referCopyButton.addEventListener('click', () => {
    navigator.clipboard.writeText(referCopyButton.getAttribute('data-refer-link'));

    referCopyButton.querySelector('.btn-text').innerHTML = 'Copied';
    setTimeout(() => {
      referCopyButton.querySelector('.btn-text').innerHTML = 'Copy Link';
    }, 2000);
  });
  }
});

class ProductLineItem extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productId = this.getAttribute('data-product-id');
    this.coffeeBrew = this.getAttribute('data-coffee-brew');
    this.grindType = this.getAttribute('data-grind-type');
    this.editGrindTypeModal = document.querySelector('edit-grind-type-modal');
    this.swapCoffeeModal = document.querySelector('swap-coffee-subscription-modal');
    this.subscriptionId = this.getAttribute('data-subscription-id');
    this.variantId = this.getAttribute('data-variant-id');
    this.playlistHandle = this.getAttribute('data-playlist-handle');
    
    this.grindPreferenceSelector = this.editGrindTypeModal.querySelector('grind-preference-selector');
    this.querySelectorAll('[data-edit-grind-type]').forEach(item => {
      item.addEventListener('click', () => {
        this.openGrindTypeModal();
      });
    });
    this.querySelectorAll('[data-swap-coffee]').forEach(item => {
      item.addEventListener('click', () => {
        this.playlistData = window.playlistUtilities.getPlaylistData(this.playlistHandle);
        const swapCoffeeModalTitle = item.getAttribute('data-product-title');
        sessionStorage.setItem('swapCoffeeModalTitle', swapCoffeeModalTitle);
        const quantity = item.getAttribute('data-quantity');
        this.openSwapCoffeeModal(quantity);
      });
    });
   
    this.productObject = window.playlistUtilities.getProductObjectById(this.productId);
    this.playlistData = window.playlistUtilities.getPlaylistDataByProductID(this.productId);
    
  }
  openGrindTypeModal() {
    const rechargeDashboard = document.querySelector('recharge-dashboard');
    this.renderDataOnModal();
    this.editGrindTypeModal.show();
    this.editGrindTypeModal.productObject = this.productObject;
    this.editGrindTypeModal.subscriptionId = this.subscriptionId;
    this.editGrindTypeModal.grindType = this.grindType;
    this.editGrindTypeModal.coffeeBrew = this.coffeeBrew;
    this.editGrindTypeModal.variantId = this.variantId;
    this.editGrindTypeModal.onLoadGrindType();
    
    rechargeDashboard.subscriptionData.forEach(subscription => {
      if(subscription.id == this.subscriptionId){
        this.editGrindTypeModal.subscriptionData = subscription;
      }
    });

  }
  openSwapCoffeeModal(quantity) {
    const rechargeDashboard = document.querySelector('recharge-dashboard');
    this.playlistData = window.playlistUtilities.getPlaylistData(this.playlistHandle);
     
    this.swapCoffeeModal.playlistData = this.playlistData;
    this.swapCoffeeModal.subscriptionId = this.subscriptionId;
    this.swapCoffeeModal.quantity = quantity;
    if(this.productObject == null){
      this.swapCoffeeModal.productObject = {id: this.productId};
    }
    else{
      this.swapCoffeeModal.productObject = this.productObject;
    }
    rechargeDashboard.subscriptionData.forEach(subscription => {
      if(subscription.id == this.subscriptionId){
        this.swapCoffeeModal.subscriptionData = subscription;
      }
    });
    this.swapCoffeeModal.renderDataOnModal();
    this.swapCoffeeModal.show();
  }
  renderDataOnModal() {
    this.editGrindTypeModal.querySelector('[data-grindmodal-title]').innerHTML = this.productObject.title;
    this.editGrindTypeModal.querySelector('[data-grindmodal-image]').src = this.productObject.featured_image;
    if(this.coffeeBrew == 'filter'){
      this.groundOptionList = "French Press,Pour Over,Drip,Aeropress".split(',');
    }
    else{
      this.groundOptionList = "Espresso".split(',');
    }
    this.editGrindTypeModal.querySelector('select').innerHTML = this.groundOptionList.map(option => `<option value="${option.toLowerCase().replace(' ', '-')}">${option}</option>`).join('');
    if(this.grindType == 'whole-beans'){
      this.editGrindTypeModal.querySelector('input[value="whole-beans"]').click();
    }
    else{
      this.editGrindTypeModal.querySelector('input[value="ground"]').click();
    }
    this.grindPreferenceSelector.addEventListener('modal-grind-preference:change', (e) => {
      console.log(e.detail.grindPreferenceValue,"e.detail.grindPreferenceValue");
    });
  }
}

customElements.define('product-line-item', ProductLineItem);

class SingleProductSubscription extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.rechargeDashboard = document.querySelector('recharge-dashboard');
    this.productId = this.getAttribute('data-product-id');
    this.variantId = this.getAttribute('data-variant-id');
    this.subscriptionId = this.getAttribute('data-subscription-id');
    this.manageSubscriptionModal = document.querySelector('manage-single-subscription');
    this.rechargeDashboard.subscriptionData.forEach(subscription => {
      if(subscription.id == this.subscriptionId){
        this.subscriptionData = subscription;
        this.subscriptionProperties = subscription.properties;
      }
    });

    this.activeSubscription = this.subscriptionData.status == 'active';
    this.init();
  }
  async init() {
    await this.getProductData();
    this.errorChargesResponse = await recharge.charge.listCharges(window.rechargeSession,{purchase_item_id:this.subscriptionId,status:"error"});
    console.log("this.errorChargesResponse",this.errorChargesResponse);
    this.errorChargesData = this.errorChargesResponse.charges;
console.log("this.errorChargesData",this.errorChargesData);

    this.errorCharge = this.errorChargesData.length > 0 ? this.errorChargesData[0] : false;
    console.log("this.errorCharge",this.errorCharge);
    this.renderSingleProductSubscription(this.subscriptionData,this.productData,this.errorCharge);
    this.querySelectorAll('[data-manage-subscription]').forEach(item => {
      item.addEventListener('click', () => {
        this.openManageSubscriptionModal(this.subscriptionData,this.productData);
      });
    });
    this.querySelectorAll('[data-activate-subscription]').forEach(item => {
      item.addEventListener('click', () => {
        this.activateSubscription(this.subscriptionData);
      });
    });
  }
  async activateSubscription(subscriptionData) {
    try {
      await recharge.subscription.activateSubscription(window.rechargeSession, subscriptionData.id);
      document.dispatchEvent(new CustomEvent('update:subscriptionDashboard'));
    } catch (error) {
      console.error(error);
    }
    await recharge.subscription.activateSubscription(window.rechargeSession, subscriptionData.id);
    this.activeSubscription = true;
    this.renderSingleProductSubscription(this.subscriptionData,this.productData,this.errorCharge);
  }
  openManageSubscriptionModal(subscriptionData,productData) {
    this.manageSubscriptionModal.subscriptionData = subscriptionData;
    this.manageSubscriptionModal.productObject = productData;
    this.manageSubscriptionModal.renderDataOnModal();
    this.manageSubscriptionModal.show();
  }
  async getProductData() {
    const productData = await recharge.product.productSearch(window.rechargeSession, {
      id: this.productId,
      format_version: '2022-06',
    });
    
    this.productData = productData.products[0];
  }
  renderSingleProductSubscription(subscriptionData,productData,errorCharge) {
    let brewTag = "";
    if(productData.tags.includes('filter')){
      brewTag = window.subscriptionHelper.getBrewTag(subscriptionData, 'filter');
    }
    else{
      brewTag = window.subscriptionHelper.getBrewTag(subscriptionData, 'espresso');
    }
    console.log(brewTag,"brewTag");
    this.innerHTML = `
      
        <div class="lg:hidden">
          <div class="lg:text-lg text-base font-bold heading leading-tight tracking-none mb-1">
            ${subscriptionData.product_title}
          </div>
          <div class="flex gap-2d5"> 
            <p class="lg:text-sm text-2sm mt-0 mb-0 leading-normal">${subscriptionData.variant_title}</p>
            ${brewTag.grind ? `<p class="mt-0 account-tag mb-0 lg:text-sm text-2sm leading-normal ${brewTag.grind == 'whole-beans' || brewTag.grind == 'whole-bean' ? 'tag-primary' : 'tag-secondary'}">${Utility.stringHelper.formateGrindType(brewTag.grind)}</p>` : ''}
          </div>
        </div>
        <div class="flex gap-4 ${errorCharge != false ? 'flex-wrap' : ''} lg:gap-6 items-center lg:items-start">
          <img
            src="${productData.images? productData.images[0].small : productData.featured_image}"
            alt="${productData.title}"
            height="00"
            width="200"
            class="mt-0 mb-0 recurring-product-image"
          >
       
          <div class="flex flex-col recurring-product-content gap-2">
            ${errorCharge != false ? `
            <div class="product-form__error-message alert alert--error text-sm font-medium leading-tight" role="alert">
              <p class="mt-0 mb-0">We couldn’t process your ${errorCharge.last_charge_attempt_date} order</p>
              <p class="mt-0 mb-0">We’re having trouble with your account. Please contact us at <a href="mailto:orders@monogramcoffee.com">orders@monogramcoffee.com</a> to resolve.</p>
            </div>
            `:``} 
            <div class="hidden lg:block">
              <div class="lg:text-lg text-base font-bold heading leading-tight tracking-none mb-1">
                ${subscriptionData.product_title}
              </div>
              <p class="mt-0 mb-1 lg:text-sm text-2sm leading-normal">${subscriptionData.variant_title}</p>
              ${brewTag.grind ? `<p class="mt-0 mb-0 account-tag lg:text-sm text-2sm leading-normal ${brewTag.grind == 'whole-beans' || brewTag.grind == 'whole-bean' ? 'tag-primary' : 'tag-secondary'}">${Utility.stringHelper.formateGrindType(brewTag.grind)}</p>` : ''}
            </div>
            <div class="flex flex-wrap items-center gap-2 recurring-product-price">
              <p class="lg:text-base text-sm mt-0 mb-0 leading-none">${subscriptionData.quantity} x ${theme.Currency.formatMoney(subscriptionData.price, theme.settings.moneyFormat)}</p>
              <p class="account-tag tag-frequency mt-0 mb-0">Every ${subscriptionData.order_interval_frequency} ${subscriptionData.order_interval_unit}</p>
            </div>
          </div>
        </div>
        <button
          class="button button--secondary button--sm w-full gap-3 current-order-mobile-button" data-manage-subscription
          role="link"
          aria-disabled="true"
        >
          <span class="btn-fill" data-fill></span>
          <span class="btn-text max-w-max"> Manage </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path d="M8 5L13 10L8 15" stroke="#6C6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        ${this.activeSubscription ? `
        <div class="hidden lg:flex items-center gap-2 cursor-pointer" data-manage-subscription> 
          <p class="text-sm leading-normal mt-0 mb-0 account-underline-text">Manage</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path d="M8 5L13 10L8 15" stroke="#6C6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        ` : `
        <div class="hidden lg:flex items-center gap-2 cursor-pointer" data-activate-subscription> 
          <p class="text-sm leading-normal mt-0 mb-0 account-underline-text">Activate</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path d="M8 5L13 10L8 15" stroke="#6C6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        `}
    `;
  }
}

customElements.define('single-product-subscription', SingleProductSubscription);

function applySpacingDivDummy(){
  let spacingDivDummy = document.querySelector('[data-spacing-div-dummy]');
  let spacingDivSelectors = ['[data-spacing-1]','[data-spacing-2]'];
  if(spacingDivDummy){
    let total_spacing = 0;
    spacingDivSelectors.forEach(selector => {
      let spacingDiv = document.querySelector(selector);
      if(spacingDiv){
        total_spacing += spacingDiv.offsetHeight;
        total_spacing += parseInt(getComputedStyle(spacingDiv).marginBottom);
      }
    });
    if(window.innerWidth <= 1024){
      total_spacing = 0
    }
    spacingDivDummy.style.height = `${total_spacing}px`;
  }
}
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('window:resize', () => {
    applySpacingDivDummy();
  })
});